import { useSelector } from "react-redux";
import { useEffect, useRef, useState, useMemo } from "react";
import { Modal, Row, Col, Button, Spinner } from "react-bootstrap";
import { Icon } from '@iconify/react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput, 
  ConversationHeader
} from '@chatscope/chat-ui-kit-react';
import _ from 'lodash';

import React from "react";

import APICom from "../../utils/helpers/APICom.js";
import ITCLogo from '../../assets/Images/CommonImages/ITC_Logo_White.png';
import ClearFilterIcon from '../../assets/Images/CommonImages/clearFilter.png';
import PersistStorage from "../../utils/helpers/PersistStorage.js";
import {
  clearPendingDriverMessage,
  hasAnyPendingDriverMessage,
  hasPendingDriverMessage,
  setMessagingHeaderNotification,
  setPendingDriverMessage,
  getUnmatchedAlerts,
  saveUnmatchedAlerts,
  addUnmatchedAlerts,
  normalizeVehNo
} from "../../utils/helpers/messagingNotificationState.js";
import MultiSelectDropdown from "./multiselectdropdown.js";
import DateTimeUtils from "../../utils/DateTimeUtility.js";
import GridControl from "./gridControl.js";

const ALL_AFFILIATES_VALUE = "all";
const AFFILIATE_BADGE_COLORS = ["#2563eb", "#0f766e", "#b45309", "#7c3aed", "#be123c", "#047857", "#4338ca", "#b91c1c"];

const Messaging = (props) => {

  // Poll interval for LoadGeneralMessages.
  // Raised from 500ms to 2000ms: the C-4 fix (parallel DB calls) halved per-poll latency,
  // which inadvertently increased the effective polling rate. 2000ms matches standard
  // real-time messaging clients and keeps DB load proportional to dispatcher count.
  const DRIVERMSGTIMER = 2000;
  
  const { ASCSSettingData, AffiliateData, AttributeData, RCZZoneVerticesData, ZoneVerticesData, isLoading, GlobalASCSData } = useSelector((store) => store.combinedata);
  const { loginData }  = useSelector((store) => store.login);

  const [sendMsgOptionsFlag, setSendMsgOptionsFlag] = useState({popup: false, voice: false});
  const [driverStatusFlag, setDriverStatusFlag] = useState('Active');
  const [driversBlockList, setDriversBlockList] = useState([]);
  // C-2 fix: keep a ref that mirrors driversBlockList so async closures (setTimeout
  // callbacks firing 2000ms later) always read the current list, not a stale snapshot.
  const driversBlockListRef = useRef([]);
  const [affiliateDropDownHTML, setAffiliateDropDownHTML] = useState(null);
  const [selectedAff, setSelectedAff] = useState(()=>{
    const passedAff = PersistStorage.retrieve('passedAff', true);
    const accessibleAffiliateIDs = getAccessibleAffiliateIDs();
    if (accessibleAffiliateIDs.length > 1) {
      return ALL_AFFILIATES_VALUE;
    }
    if (passedAff && accessibleAffiliateIDs.includes(String(passedAff))) {
      return parseInt(passedAff);
    }
    return accessibleAffiliateIDs[0] ? parseInt(accessibleAffiliateIDs[0]) : (AffiliateData?.[0]?.AffiliateID || "");
  });
  const [driverFilterInput, setDriverFilterInput] = useState('');
  const [createGroupFlag, setCreateGroupFlag] = useState(false);
  const [groupNameAssigned, setGroupNameAssigned] = useState('');
  const [, setDispatchMethod] = useState(1);
  const [driverBlockListActiveCheck, setDriverBlockListActiveCheck] = useState([]);
  const [driverCardMsgList, setDriverCardMsgList] = useState([]);
  const [DriversFilterMultiSelect, SetDriversFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Driver(s)",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarMessaging small", 
    AllItemsSelectedPlaceHolder:"All Drivers", SelectAllPlaceHolder:"Select All",
    styles:{ width:"189px", maxHeight:"30px", display:"block", minWidth:"120px", height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}
  });
  const [VehiclesFilterMultiSelect, SetVehiclesFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Vehicle(s)",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarMessaging small", 
    AllItemsSelectedPlaceHolder:"All Vehicles", SelectAllPlaceHolder:"Select All",
    styles:{ width:"189px", maxHeight:"30px", display:"block", minWidth:"120px", margin:'4px', height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}
  });
  const [ZonesFilterMultiSelect, SetZonesFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Zone(s)",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarMessaging small", 
    AllItemsSelectedPlaceHolder:"All Zones", SelectAllPlaceHolder:"Select All",
    styles:{ width:"189px", maxHeight:"30px", display:"block", minWidth:"120px", margin:'4px', height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}
  });
  const [AttributesFilterMultiSelect, SetAttributesFilterMultiSelect] = useState({options: [], selectedValues:[], placeholder:"Attributes",
    displayValue:"name", emptyRecordMsg:"N/A", id:"DispatchGridAttributesSelect", className:"callAgentInputStyle border-0 text-nowrap toolbarMessaging small", 
    AllItemsSelectedPlaceHolder:"All Attributes", SelectAllPlaceHolder:"",
    styles:{ width:"189px", maxHeight:"30px", display:"block", minWidth:"120px", margin:'4px', height:"30px", backgroundColor:"#e6eef1", border:0, borderRadius:"5px"}
  });
  const [multiSelectValuesSelected, setMultiSelectValuesSelected] = useState({drivers: [], vehicles: [], zones: [], attributes: []});
  const [chatType, setChatType] = useState('chat');
  const [givenDateRange, setGivenDateRange] = useState('today');
  const [activeVehNo, setActiveVehNo] = useState(null);
  const [groupByFilter] = useState('Drivers');
  const [showPopup, setShowPopup] = useState({show: false, groupDict: {}});
  const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });
  const [popupDriversList, setPopupDriversList] = useState([]);
  const [calendarMinMax, setCalendarMinMax] = useState({min: '', max: '', selected: ""});
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarPos, setCalendarPos] = useState({ top: 0, left: 0 });
  const [openMsgScheduleView, setOpenMsgScheduleView] = useState(false);
  const [showAddScheduleDisplay, setShowAddScheduleDisplay] = useState(false);
  const [MsgSchGridOptions] = useState({
      height: 320,
      heightoffset: 600,
      calculateHeight: false,
      pagination: true,
      sortCondition: true,
      paginationSize: 5,
      paginationSizeSelector: [5, 10, 15, 20, 25],
      selectable: 1,
      reactiveData:false, //enable data reactivity
      layout: "fitDataStretch",
      placeholder:"No Data Available",
      clipboard: false,
      selectableRangeMode: "click",
      GridName:"MsgSchGrid",
      paginationCounter:"rows",
      intervalTimer: 0,
      movableColumns:true,
      vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
      index: "iID",
      autoColumns: true,
      bSysUser: 1,
      intervalEnable: false,
      persistence: false,
      bWebApplySettingToAll: true,
      GridReturnOnlyIDColumnInRowData: false,
      containerClass: "col position-relative",
      Containerstyle: {},
      footerElement: '<button class="tabulator_btns raised-button border border-dark me-2 " title="Clear Filters" id="MsgSchGrid_ClearFilters"></button>',
      tableDoubleClickFunc: function(table, row) {

      },
      footerElementHandles: function (table) {
        msgSchGridRef.current = table;
        
        let img = document.createElement("img");
          img.style.cssText = "width:16px; height:16px"; 
          img.src = ClearFilterIcon;
          document.getElementById("MsgSchGrid_ClearFilters").appendChild(img);
        document.getElementById('MsgSchGrid_ClearFilters').addEventListener("click", function(){
          table.clearHeaderFilter();
        });
      },
      rowSelectionChangeHandle: function (data) {  
        try{
          
        }
        catch(err){console.log(err);}
      },
      ActionList: false,
      AlwaysHiddenColumns: []
  });
  const [showLoader] = useState(false);
  const [msgSchGridData] = useState([{"Schedule Name": '', "Created Date": '', 'Modified Date': '', 'Created By ID': '', 'Active': '', 'IsRecurring': '', 'iID': -1, 'AffiliateID': ''}]);
  const [addSchToggleOptions, setAddSchToggleOptions] = useState({recurring: false, popup: false, active: true});
  const [createSchDetails, setCreateSchDetails] = useState({name: '', time: '', extra: '', days: {mon: false, tue: false, wed: false, thurs: false, fri: false, sat: false, sun: false}});

  const [specialMsgDetails, setSpecialMsgDetails] = useState({title:'', body: '', option: 'OK'});
  const [blinkRecentMsg, setBlinkRecentMsg] = useState('');
  // M-1: surface polling errors so the dispatcher knows messages are retrying, not silently dead.
  const [pollingError, setPollingError] = useState('');
  const [warningMsg, setWarningMsg] = useState('');

  const dateChanged= useRef(0);
  const activeDriver = useRef(null);
  const pollSessionRef = useRef(0);
  // M-2 fix: useState instead of useRef so the 'All Messages to Driver' checkbox toggle
  // actually triggers the useEffect that refreshes devices. useRef mutations are invisible
  // to React's dependency tracking — the effect never fired on toggle.
  const [allMsgToDriverFlag, setAllMsgToDriverFlag] = useState(false);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [docTitle, setDocTitle] = useState("Messaging 2.0");


  // Dedicated cancel tokens per API flow — prevents one flow from accidentally cancelling another (CRITICAL-2)
  const cancelDevicesRef = useRef(null); // LoadSmartDevices
  const cancelMsgRef = useRef(null);     // LoadGeneralMessages (polling)
  const cancelPopupRef = useRef(null);   // LoadGroupDevicesList (popup hover)
  const loadSmartDevicesRef = useRef(0);
  const loadDriverMsgRef = useRef(0);
  const groupNameFieldRef = useRef(null);
  const driverCardRef = useRef([]);
  const dateRangeFromRef = useRef('Yesterday');
  const msgIDRecordDict = useRef({lastMsgID: '-1', NewMessageAlertLastMsgID: '-1', deviceRefNum: '-1'});
  const msgIDRef = useRef(-1);
  const globalInLoadAPIURL = useRef((GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL") ? GlobalASCSData.find(dict => dict.SubTitle === "InLoadAPI_URL").value : ""));
  const indexRef = useRef(0);
  const driverSearchFilterIntervalRef = useRef(null);
  const pageLoadRef = useRef(true);
  const affiliateSelectionInitializedRef = useRef(false);
  const dispatcherSend = useRef(false);
  const driverFilterInputRef = useRef('');
  const messageInputRef = useRef(null);
  const spanPopupRef = useRef([]);
  const dateSelectRef = useRef(null);
  const calendarSpanRef = useRef(null);
  const calendarInputRef = useRef(null);
  const msgSchGridRef = useRef(null);
  const msgListRef = useRef(null);
  const WebMRMS_URL = useRef((GlobalASCSData.find(dict => dict.SubTitle === "WebMRMSURL") ? GlobalASCSData.find(dict => dict.SubTitle === "WebMRMSURL").value : ""));
  const [scheduleDialog, setScheduleDialog] = useState({Display:false, URL: "", isLoading: true });

  // M-3 + L-1 fix: senderColorMap was a `let` rebuilt from scratch on every render.
  // useMemo makes it a stable `const` that only recomputes when msgList actually changes.
  const senderColorMap = useMemo(() => {
    const map = new Map();
    if (driverCardMsgList?.msgList?.length > 0) {
      const uniqueSenders = [...new Set(driverCardMsgList.msgList.map(item => item.msgFrom))];
      uniqueSenders.forEach((sender, index) => {
        const hue = (index * 137.508) % 360;
        map.set(sender, `hsl(${hue}, 70%, 80%)`);
      });
    }
    return map;
  }, [driverCardMsgList?.msgList]);

  const filterOptionsMap = {
    Drivers: {
      options: DriversFilterMultiSelect,
      setOptions: SetDriversFilterMultiSelect
    },
    Vehicles: {
      options: VehiclesFilterMultiSelect,
      setOptions: SetVehiclesFilterMultiSelect
    },
    Zones: {
      options: ZonesFilterMultiSelect,
      setOptions: SetZonesFilterMultiSelect
    },
    Attributes: {
      options: AttributesFilterMultiSelect,
      setOptions: SetAttributesFilterMultiSelect
    }
  };

  function getAccessibleAffiliateIDs() {
    try {
      const rawAffiliateList = loginData?.UserAffiliateList || "";
      const loginAffiliateIDs = String(rawAffiliateList)
        .split(",")
        .map(item => item.trim())
        .filter(item => item !== "" && !Number.isNaN(parseInt(item, 10)));

      const allowedIDs = new Set(loginAffiliateIDs);
      const dataAffiliateIDs = (AffiliateData || [])
        .filter(item => allowedIDs.size === 0 || allowedIDs.has(String(item.AffiliateID)))
        .map(item => String(item.AffiliateID));

      return [...new Set(dataAffiliateIDs.length > 0 ? dataAffiliateIDs : loginAffiliateIDs)];
    } catch (err) {
      return [];
    }
  }

  function isAllAffiliatesSelected(value = selectedAff) {
    return String(value).toLowerCase() === ALL_AFFILIATES_VALUE;
  }

  function getSelectedAffiliateIDs(value = selectedAff) {
    if (isAllAffiliatesSelected(value)) {
      return getAccessibleAffiliateIDs();
    }

    const selectedAffiliateID = String(value || "").trim();
    return selectedAffiliateID !== "" ? [selectedAffiliateID] : [];
  }

  function getSelectedAffiliateList(value = selectedAff) {
    return getSelectedAffiliateIDs(value).join(",");
  }

  function getPrimaryAffiliateID(value = selectedAff) {
    const affiliateIDs = getSelectedAffiliateIDs(value);
    return affiliateIDs.length > 0 ? parseInt(affiliateIDs[0], 10) : -1;
  }

  function getAffiliateDetails(affiliateID) {
    return (AffiliateData || []).find(item => String(item.AffiliateID) === String(affiliateID));
  }

  function getAffiliateName(affiliateID, fallbackName = "") {
    const affiliateDetails = getAffiliateDetails(affiliateID);
    return fallbackName || affiliateDetails?.AffiliateCompany || `Affiliate ${affiliateID}`;
  }

  function getAffiliateBadgeColor(affiliateID) {
    if (String(affiliateID) === 'all') {
      return '#4b5563'; // Neutral gray color for All Affiliates broadcast
    }
    const affiliateIDs = getAccessibleAffiliateIDs();
    const affiliateIndex = Math.max(affiliateIDs.findIndex(item => String(item) === String(affiliateID)), 0);
    return AFFILIATE_BADGE_COLORS[affiliateIndex % AFFILIATE_BADGE_COLORS.length];
  }

  function buildCardKey(card = {}) {
    return [
      card.affiliateID || "unknown",
      card.deviceID || "",
      card.vehNo || "",
      card.driverNo || "",
      card.group || ""
    ].join("|");
  }

  function enrichDeviceCard(card = {}) {
    const affiliateID = String(card.affiliateID || getPrimaryAffiliateID());
    const enrichedCard = {
      ...card,
      affiliateID,
      affiliateName: getAffiliateName(affiliateID, card.affiliateName),
      affiliateColor: getAffiliateBadgeColor(affiliateID)
    };

    return {
      ...enrichedCard,
      cardKey: buildCardKey(enrichedCard)
    };
  }

  function getDispatchMethodForAffiliate(affiliateID) {
    try {
      return affiliateID && ASCSSettingData[affiliateID]
        ? JSON.parse(ASCSSettingData[affiliateID]).find((item) => item.SubTitle === "DispatchMethod").value
        : 1;
    } catch (err) {
      return 1;
    }
  }

  function activateFirstBroadcast(list = driverBlockListActiveCheck) {
    const broadcastIndex = list.findIndex(driver => driver && driver.deviceID === "XXXX");
    if (broadcastIndex > -1) {
      indexRef.current = broadcastIndex;
      activeDriver.current = list[broadcastIndex].cardKey;
      setActiveVehNo(list[broadcastIndex].cardKey);
      return true;
    }
    return false;
  }
  
  
  /**
   * Loads necessary data on page load. e.g. affiliate info, user login info, 
   * calls for load of vehicle devices like MDT and PIM
   */
  useEffect(() => {
    try{
      //ADDED FOR REMOVAL OF SPECIAL CHAT OPTIONS
      setChatType('chat'); 
      setSpecialMsgDetails({title:'', body: '', option: 'OK'});
      document.title = docTitle;
      let resizeTimer = 0;

      // Initial center
      centerSelect();

      //End of an initial loading phase.
      setTimeout(() => {
        pageLoadRef.current = false;
      }, 500);

      function centerSelect() {
        try{
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            const container = msgListRef.current;
            const select = dateSelectRef.current;
            if (container && select) {
              const right = (container.clientWidth - select.offsetWidth) / 2;

              select.style.right = `${right}px`;
            }
          }, 100);
        } catch(err) {console.log(err);}
      }

      window.addEventListener('resize', centerSelect);
      
      return () => {
        window.removeEventListener('resize', centerSelect);
        clearTimeout(loadSmartDevicesRef.current);
        clearTimeout(loadDriverMsgRef.current);
        localStorage.removeItem('activeMessagingDriver');
      };

    } catch(err){console.log(err);}

    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      const loginUserAffiliateList = getAccessibleAffiliateIDs();
      const affiliateOptionsHTML = [
        ...(loginUserAffiliateList.length > 1 ? [<option key="all-affiliates" value={ALL_AFFILIATES_VALUE}>All Affiliates</option>] : []),
        ...AffiliateData.map(function(item, index){ //filtering only affiliates that the user has access to
          if(loginUserAffiliateList.includes(String(item.AffiliateID)))
          {
            return (
              <option key={index} value={item.AffiliateID}>{item.AffiliateCompany}</option>
            );
          }
          return null;
        })
      ];

      setAffiliateDropDownHTML(affiliateOptionsHTML);

      if (loginUserAffiliateList.length === 0) {
        return;
      }

      setSelectedAff(prevSelectedAff => {
        const prevSelectedAffValue = String(prevSelectedAff || "");
        if (!affiliateSelectionInitializedRef.current) {
          affiliateSelectionInitializedRef.current = true;
          return loginUserAffiliateList.length > 1
            ? ALL_AFFILIATES_VALUE
            : parseInt(loginUserAffiliateList[0], 10);
        }

        if (loginUserAffiliateList.length > 1) {
          if (
            prevSelectedAffValue === "" ||
            prevSelectedAffValue.toLowerCase() === "undefined" ||
            !loginUserAffiliateList.includes(prevSelectedAffValue)
          ) {
            return ALL_AFFILIATES_VALUE;
          }
          return prevSelectedAff;
        }

        return prevSelectedAffValue === String(loginUserAffiliateList[0])
          ? prevSelectedAff
          : parseInt(loginUserAffiliateList[0], 10);
      });
    } catch(err) { console.log(err); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginData?.UserAffiliateList, AffiliateData]);

  useEffect(() => {

    setDriversBlockList(prev=>prev.map((item, i) => {
      const hasPending = hasPendingDriverMessage({ affiliateID: item.affiliateID, vehNo: item.vehNo, driverNo: item.driverNo });
      if(hasPending){
        
        dispatcherSend.current = false;
        return {...item, blink: true};
      
      }
      else{
        return item;
      }
    }));

   
  }, [activeVehNo])

  useEffect(() => {
    if (activeVehNo) {
      const selectedDriverCard = driversBlockList.find(card => card.cardKey === activeVehNo);
      if (selectedDriverCard) {
        localStorage.setItem('activeMessagingDriver', JSON.stringify({
          affiliateID: String(selectedDriverCard.affiliateID || ""),
          vehNo: String(selectedDriverCard.vehNo || ""),
          driverNo: String(selectedDriverCard.driverNo || "")
        }));
        return;
      }
    }
    localStorage.removeItem('activeMessagingDriver');
  }, [activeVehNo, driversBlockList]);

  useEffect(() => {
    document.title = docTitle;
  }, [docTitle])

  /**
   * changes dispatch method and loads smart devices when affiliate is changed
   */
  useEffect(()=>{
    try{
      const selectedAffiliateValue = selectedAff;
      const selectedAffiliateList = getSelectedAffiliateList(selectedAffiliateValue);
      const dispatcherUserID = parseInt(loginData?.iUserID, 10);
      if(!selectedAffiliateValue || !selectedAffiliateList || !loginData?.UserAffiliateList || Number.isNaN(dispatcherUserID) || dispatcherUserID <= 0){
        return;
      }

      setMessagesLoading(true);
      if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
      if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}

      setDriverCardMsgList([]); // Immediately clear the message list from the UI
      setDriversBlockList([]);
      setDriverBlockListActiveCheck([]);
      driverCardRef.current = [];
      setActiveVehNo(null); 
      activeDriver.current = "BroadCast" 

      //Sets the DispatchMethod from ASCSSettingData for the selected affiliate
      setDispatchMethod(getDispatchMethodForAffiliate(getPrimaryAffiliateID(selectedAffiliateValue)));
      loadSmartDevices('first', selectedAffiliateValue);
    }
    catch(err){console.log(err); setMessagesLoading(false);}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAff, loginData?.iUserID, loginData?.UserAffiliateList]);


  /**
   * fetches driver messages when a new driver block is active
   */
  useEffect(()=>{
    try{
      // H-3 fix: guard with pageLoadRef.current so this path only fires during the initial
      // load window (first 500ms). Without this, if loadSmartDevices takes >500ms the
      // activeVehNo effect also becomes active, causing both effects to call
      // handleGetDriverMsg simultaneously and start two competing poll loops.
      if(driverBlockListActiveCheck.length > 0 && msgIDRef.current > -1 && pageLoadRef.current){
        handleGetDriverMsg(msgIDRef.current);
        msgIDRef.current = -1;
      }

    } catch(err){console.log(err);}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driverBlockListActiveCheck]);


  /**
   * stops the blinking for a new message?
   */
  useEffect(()=>{
    try{
      if(driversBlockList.length > 0){
        const driverWithBlink = driversBlockList.find(card => card.blink);
        if(!driverWithBlink){setBlinkRecentMsg(''); setDocTitle("Messaging 2.0");}
      }

    } catch(err){console.log(err);}
  }, [driversBlockList]);

  // C-2 fix: keep driversBlockListRef in sync with driversBlockList state.
  // Refs are mutable and not bound by closure semantics, so async callbacks
  // (setTimeout polling) always read the latest driver list via the ref.
  useEffect(() => { driversBlockListRef.current = driversBlockList; }, [driversBlockList]);


  /**
   * handles the change in active vehicle
   */
  useEffect(() => {
    try{
      if(activeVehNo){
        //removes the message from local storage, and checks if any cards are blinking
        const selectedDriverCard = driversBlockList.find(card => card.cardKey === activeVehNo);
        clearPendingDriverMessage({ affiliateID: selectedDriverCard?.affiliateID, vehNo: selectedDriverCard?.vehNo, driverNo: selectedDriverCard?.driverNo });
        

        setDriversBlockList(prev => prev.map((val) => ({
            ...val,
            blink: (val.cardKey === activeVehNo ? false : val.blink)
          }))
        );
        if(!pageLoadRef.current){
          handleGetDriverMsg(activeVehNo, 'first'); //If the page has already finished loading, immediately loads the first message for the selected driver
        }

        const driverWithBlink = driversBlockList.find(card => card.blink && card.cardKey !== activeVehNo);
        //if no cards are blinking, removes the notification icon from the d2.0 header
        if(!driverWithBlink){setMessagingHeaderNotification(hasAnyPendingDriverMessage() || getUnmatchedAlerts().length > 0)}
      }
      else{
        pollSessionRef.current += 1; // Terminates active polling loops
        msgIDRecordDict.current.lastMsgID = -1;
        setTimeout(() => {
          if(driversBlockList.length > 0 && driversBlockList[(indexRef.current)]?.blink){
            setDriversBlockList(prev=>prev.map((val, i)=>({
                ...val,
                blink: (i === (indexRef.current) ? false : val.blink)
              }))
            );

            const driverWithBlink = driversBlockList.find(card => card.blink && card.cardKey !== activeVehNo);
            //if no cards are blinking, removes the notification icon from the d2.0 header
            if(!driverWithBlink){setMessagingHeaderNotification(hasAnyPendingDriverMessage() || getUnmatchedAlerts().length > 0)}

          }
          
          if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
          
          setDriverCardMsgList([]);
        }, 500);
      }
    } catch(err){console.log(err);}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeVehNo]);
  /**
   * triggers a delated device refresh
   */
  useEffect(() => {
    try{
      if(!pageLoadRef.current){
        if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
        loadSmartDevices('later');
      }

    } catch(err){console.log(err);}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driverStatusFlag, allMsgToDriverFlag]);


  useEffect(() => {
    try{
      if(calendarMinMax.selected !== '' && warningMsg === ''){
        pollSessionRef.current += 1;
        const mySession = pollSessionRef.current;
        if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
        loadDriverMsgRef.current = setTimeout(async () => {
          if (mySession === pollSessionRef.current) {
            await handleGetDriverMsg(activeDriver.current || 0, 'second');
          }
        }, DRIVERMSGTIMER);
      }
    } catch(err){console.log(err);}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calendarMinMax]);

  /**
   * Resets the calendar selection and date range to the default state.
   */
  // eslint-disable-next-line no-unused-vars
  function resetCalendar () {
    try{
      setShowCalendar(false); setGivenDateRange('today'); 
      dateRangeFromRef.current = 'today';
      setCalendarMinMax(prev=>({...prev, selected: ''}));

    } catch(err){console.log(err);}
  }

   
/**
 * Handles sending a message to a device(s) or group(s)
 * @param {string} msg The message to be sent
 * @returns {Promise<void>} A promise that resolves when the message has been sent
 */
  async function handleMsgSent (msg) {
    try{
      if(msg && msg.trim() !== '' && driverBlockListActiveCheck.length > 0){
        let deviceNo = '';
        let vehNo = '';
        let isGroup = false;
        let currentAffiliateID = getPrimaryAffiliateID();
        
        const currentDriver = driverBlockListActiveCheck[parseInt(indexRef.current)];
        if(currentDriver){
          deviceNo = currentDriver.deviceID;
          vehNo = currentDriver.vehNo;
          isGroup = currentDriver.group !== '-1';
          currentAffiliateID = currentDriver.affiliateID === 'all' ? 'all' : parseInt(currentDriver.affiliateID || currentAffiliateID, 10);
        }
        msg = msg.replace(/<br\s*\/?>/gi, "\n");

        if (currentAffiliateID === 'all') {
          // Send to all assigned affiliates in parallel
          const affiliateIDs = getAccessibleAffiliateIDs();
          const inloadSendMsgURL = globalInLoadAPIURL.current + "/Message/SendMessageToDevice";
          
          const promises = affiliateIDs.map(affId => {
            const data = {
              "DeviceNo": String(deviceNo),
              "Message": String(msg).replace(/(&nbsp;)/gi, ''),
              "VoiceMessage": sendMsgOptionsFlag.voice,
              "PopupMessage": sendMsgOptionsFlag.popup,
              "VehicleNo": String(vehNo),
              "ATSPID": parseInt(affId, 10),
              "UserID": String(loginData.iUserID),
              "UserName": String(loginData.vUserName),
              "IsPowerUser": loginData.IsPowerUser,
            };
            return APICom.fetchData('full', inloadSendMsgURL, "post", { "Content-Type": "application/json" }, data, null);
          });
          
          await Promise.all(promises);
          dispatcherSend.current = true;
          return;
        }

        let data = (isGroup && !deviceNo.includes('X')? 
          {
            "ATSPID": currentAffiliateID,
            "iGroupID" : parseInt(deviceNo),
            "UserID": String(loginData.iUserID),
            "UserName" : String(loginData.vUserName),
            "Message": String(msg).replace(/(&nbsp;)/gi, ''),
            "IsPowerUser": loginData.IsPowerUser,
          }
          :
          {
            "DeviceNo": String(deviceNo),
            "Message": String(msg).replace(/(&nbsp;)/gi, ''),
            "VoiceMessage": sendMsgOptionsFlag.voice,
            "PopupMessage": sendMsgOptionsFlag.popup,
            "VehicleNo": String(vehNo),
            "ATSPID": currentAffiliateID,
            "UserID": String(loginData.iUserID),
            "UserName": String(loginData.vUserName),
            "IsPowerUser": loginData.IsPowerUser,
          }
        );
        const inloadSendMsgURL = globalInLoadAPIURL.current + (isGroup && !deviceNo.includes('X') ? "/Message/SendGroupMessageToDevices" : "/Message/SendMessageToDevice");
        await APICom.fetchData('full', inloadSendMsgURL, "post", { "Content-Type": "application/json" }, data, null);
        dispatcherSend.current = true;
        
      }

    } catch(err) {console.log(err);}
  }


  /**
   * Prepares and sends an API request to delete a group
   * @param {*} groupDict Dictionary containing the group to be deleted
   */
  async function deleteSelectedGroup (groupDict) {
    try{
      let data = {
        "ATSPID": parseInt(groupDict.affiliateID || getPrimaryAffiliateID(), 10),
        "GroupID": parseInt(groupDict.deviceID),
      };
      const removeResp = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/DeleteMessagingGroup", "post", { "Content-Type": "application/json" }, data, null);
      //reloads the smart devices once deletion is confirmed
      if(removeResp && removeResp.error.length === 0){
        if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
        await loadSmartDevices();
      }

    } catch(err){console.log(err);}
  }

  // eslint-disable-next-line no-unused-vars
  async function editSelectedGroup (groupDict) {
    try{
      console.log("edit clicked");

    }
    catch(err){console.log(err);}
  }

  /**
   * Filters the driver list and polls it every 300ms
   * This logic ensures the backend is only hit after the user stops typing for >= timeInterval
   * @param {*} e Event value holding filter criteria (String)
   */  
  function handleFilterDrivers (e) {
    try{
      const trimmedInput = e.target.value.trim();
      setDriverFilterInput(e.target.value);
      driverFilterInputRef.current = trimmedInput;
      if(driverSearchFilterIntervalRef.current){clearTimeout(driverSearchFilterIntervalRef.current);}

      driverSearchFilterIntervalRef.current = setTimeout(async () => {
        try{
          if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
          await loadSmartDevices('later');
        }
        catch(err){console.log(err);}
      }, 300);
    }
    catch(err) {console.log(err);}
  }


  /**
   * Creates a group of drivers
   * I don't really see how these persist? 
   * @param {*} e Event value holding name for group? 
   */
  async function addGroupOfDrivers (e) {
    try{
      if(isAllAffiliatesSelected()){
        return;
      }
      //if valid group, reloads smart devices
      if(groupNameAssigned && groupNameAssigned.trim() !== ''){
        const IDs = multiSelectValuesSelected[(groupByFilter.toLowerCase())];
        let data = {
          "atspid": getPrimaryAffiliateID(),
          "dispatcherUserID": String(loginData.iUserID),
          "groupName": groupNameAssigned,
          "mode": String(groupByFilter),
          "driverIDs": String(IDs)
        };
        // WHERE have my groups gone? 
        const addGroupResp = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/CreateMessagingGroup", "post", { "Content-Type": "application/json" }, data, null);
        if(addGroupResp.error.length > 0){
          //unfinished
        }
        setCreateGroupFlag(false);
        loadSmartDevices();
      }
      else
      {
        //flashing error for invalid name
        groupNameFieldRef.current.style.border = "2px solid red";
        setTimeout(() => {
          if(groupNameFieldRef.current){
            groupNameFieldRef.current.focus();
            groupNameFieldRef.current.style.borderColor = '';
            groupNameFieldRef.current.style.borderWidth = '';
          }
        }, 1000);
      }

    } catch (err) {console.log(err);}
  }


  /**
   * Loads the list of "smart devices"
   * Populates drop down too? 
   * @param {*} occurance = 'first' = Initializes the broadcast device’s vehicle number via setActiveVehNo(...)
   * @param {*} occurance = Skips setting the active vehicle and resets the message index (msgIDRef.current = -1)
   */
  async function loadSmartDevices (occurance = 'first', selectedAffiliateValue = selectedAff) {
    try{
      const affiliateList = getSelectedAffiliateList(selectedAffiliateValue);
      const primaryAffiliateID = getPrimaryAffiliateID(selectedAffiliateValue);
      const dispatcherUserID = parseInt(loginData?.iUserID, 10);
      if(!affiliateList || primaryAffiliateID <= 0 || Number.isNaN(dispatcherUserID) || dispatcherUserID <= 0){
        setMessagesLoading(false);
        return;
      }
      let data = {
        atspid: primaryAffiliateID,
        affiliateList: affiliateList,
        showDriver: true,
        dispatcherUserID: String(dispatcherUserID)
      };
      let filteredSortedDataArr = [];
      cancelDevicesRef.current = APICom.GenerateSource(); //Cancel token for device refresh
      //API call
      const loadDeviceResponse = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/LoadSmartDevices", "post", {}, data, cancelDevicesRef.current);
      const respDataArr = loadDeviceResponse.data;
      const devicesArr = [];
      const driversArr = [];
      const vehiclesArr = [];
      const inputFilter = driverFilterInputRef.current;
      if(loadDeviceResponse && loadDeviceResponse.error.length === 0 && (respDataArr && Array.isArray(respDataArr) && respDataArr.length > 0)){
        // Match and drain locally queued unmatched alerts when the device list updates.
        const unmatched = getUnmatchedAlerts();
        if (unmatched.length > 0) {
          const newlyMatched = [];
          const remainingUnmatched = [];

          unmatched.forEach(alert => {
            const matchedDevice = respDataArr.find(dev => {
              const devAffiliateID = String(dev.SDAffiliateID && dev.SDAffiliateID !== "-1"
                ? dev.SDAffiliateID
                : (dev.AffiliateID && dev.AffiliateID !== "-1" ? dev.AffiliateID : primaryAffiliateID));
              const alertAffiliateID = alert.AffiliateID && alert.AffiliateID !== "-1"
                ? String(alert.AffiliateID)
                : String(primaryAffiliateID);
              const isMatchAff = devAffiliateID === "all" || alertAffiliateID === "all" || devAffiliateID === alertAffiliateID;
              return normalizeVehNo(dev.VehNum) === normalizeVehNo(alert.VehicleNo) && isMatchAff;
            });

            if (matchedDevice) {
              newlyMatched.push({ alert, matchedDevice });
            } else {
              remainingUnmatched.push(alert);
            }
          });

          if (newlyMatched.length > 0) {
            newlyMatched.forEach(({ alert, matchedDevice }) => {
              const matchedAffID = String(matchedDevice.SDAffiliateID && matchedDevice.SDAffiliateID !== "-1"
                ? matchedDevice.SDAffiliateID
                : (matchedDevice.AffiliateID && matchedDevice.AffiliateID !== "-1" ? matchedDevice.AffiliateID : primaryAffiliateID));
              
              const targetCardKey = buildCardKey({
                affiliateID: matchedAffID,
                deviceID: matchedDevice.DeviceID,
                vehNo: matchedDevice.VehNum,
                driverNo: matchedDevice.DriverNum
              });

              // Only flag as pending if this is not the currently active driver card
              if (targetCardKey !== activeDriver.current) {
                const affiliateName = getAffiliateName(matchedAffID, matchedDevice.AffiliateCompanyName || matchedDevice.SDAffiliate || "");
                setPendingDriverMessage({
                  affiliateID: matchedAffID,
                  affiliateName: affiliateName,
                  vehNo: alert.VehicleNo,
                  driverNo: matchedDevice.DriverNum,
                  messageID: alert.MessageID
                });
              }
            });
            saveUnmatchedAlerts(remainingUnmatched);
          }
        }

        if (isAllAffiliatesSelected(selectedAffiliateValue)) {
          const allAffiliatesCard = enrichDeviceCard({
            name: 'BroadCast',
            id: -1,
            driverNo: 'XXXX',
            vehID: -1,
            vehNo: 'XXXX',
            deviceID: 'XXXX',
            active: false,
            activeDriver: 'N/A',
            group: 'Broad',
            msgList: [],
            blink: false,
            vehType: '',
            affiliateID: 'all',
            affiliateName: 'All Affiliates'
          });
          allAffiliatesCard.active = allAffiliatesCard.cardKey === activeDriver.current;
          devicesArr.push(allAffiliatesCard);
        }
        // eslint-disable-next-line no-unused-vars
        let activeCardInitialized = false;
        for(let k = 0; k < respDataArr.length; k++) //iterates through all device records in response
        {
          const responseSDAffiliateID = String(respDataArr[k].SDAffiliateID || "");
          const responseAffiliateID = responseSDAffiliateID && responseSDAffiliateID !== "-1"
            ? responseSDAffiliateID
            : String(respDataArr[k].AffiliateID || "");
          const rowAffiliateID = String(responseAffiliateID && responseAffiliateID !== "-1" ? responseAffiliateID : primaryAffiliateID);
          const rowAffiliateName = getAffiliateName(rowAffiliateID, respDataArr[k].AffiliateCompanyName || respDataArr[k].SDAffiliate || "");

          if(respDataArr[k].DeviceID === 'XXXX' && respDataArr[k].DisplayString === 'Broad Cast')
          {
            if (isAllAffiliatesSelected(selectedAffiliateValue)) {
              continue;
            }
            const broadcastCard = enrichDeviceCard({name: 'BroadCast', id: -1, driverNo: respDataArr[k].DriverNum, vehID: -1, vehNo:respDataArr[k].VehNum, deviceID: respDataArr[k].DeviceID, 
              active:false, activeDriver:'N/A', group:'Broad', msgList: respDataArr[k].sdMessageList, blink: false, vehType: respDataArr[k].VehicleType,
              affiliateID: rowAffiliateID, affiliateName: rowAffiliateName
            });
            broadcastCard.active = broadcastCard.cardKey === activeDriver.current;
            if(occurance !== 'first') {
              msgIDRef.current = -1;
            }
            //Pushes a special "BroadCast" card to devicesArr
            devicesArr.push(broadcastCard);
          }
          else if(respDataArr[k].DriverNum === 'XXXX'){
            if (isAllAffiliatesSelected(selectedAffiliateValue)) {
              continue;
            }
            const groupCard = enrichDeviceCard({name: respDataArr[k].DisplayString, id: -1, driverNo: respDataArr[k].DriverNum, vehID: -1, 
              vehNo:respDataArr[k].VehNum+"_"+respDataArr[k].DisplayString, deviceID: respDataArr[k].DeviceID, 
              active:false, activeDriver:'N/A', group:respDataArr[k].DisplayString, msgList: respDataArr[k].sdMessageList, blink: false, vehType: respDataArr[k].VehicleType,
              affiliateID: rowAffiliateID, affiliateName: rowAffiliateName
            });
            groupCard.active = groupCard.cardKey === activeDriver.current;
            devicesArr.push(groupCard);
          }
          else { //Separates driver/vehicle info and builds full device entries 
            driversArr.push({name: respDataArr[k].DriverName, id: respDataArr[k].DriverID, number: respDataArr[k].DriverNum, affiliateID: rowAffiliateID, affiliateName: rowAffiliateName});
            vehiclesArr.push({vehNum: respDataArr[k].VehNum, vehID: respDataArr[k].VehicleID, affiliateID: rowAffiliateID, affiliateName: rowAffiliateName});
            let isActive = (respDataArr[k].ImageKey.toLowerCase().includes('online') || respDataArr[k].ImageKey.toLowerCase().includes('newbusy') ? true : false);
            const deviceCard = enrichDeviceCard({name: respDataArr[k].DriverName, id: respDataArr[k].DriverID, driverNo: respDataArr[k].DriverNum,
              vehID: respDataArr[k].VehicleID, vehNo:respDataArr[k].VehNum,  deviceID:respDataArr[k].DeviceID, 
              active:false, activeDriver:isActive, group:'-1', msgList: respDataArr[k].sdMessageList,
              blink: hasPendingDriverMessage({ affiliateID: rowAffiliateID, vehNo: respDataArr[k].VehNum, driverNo: respDataArr[k].DriverNum }), vehType: respDataArr[k].VehicleType,
              affiliateID: rowAffiliateID, affiliateName: rowAffiliateName
            });
            deviceCard.active = deviceCard.cardKey === activeDriver.current;
            devicesArr.push(deviceCard);
          }
        }

        //Filters devices by 
        //Online/Offline status (driverStatusFlag)
        //Matches (name, driverNo, vehNo)
        filteredSortedDataArr = devicesArr.filter((person) => (
          person.group !== '-1' ||
          (
            ((driverStatusFlag === 'Active' && person.activeDriver) || 
            (driverStatusFlag !== 'Active' && !person.activeDriver)) &&
            (
              person.name.toLowerCase().includes(inputFilter.trim().toLowerCase()) ||
              person.affiliateName.toLowerCase().includes(inputFilter.trim().toLowerCase()) ||
              person.driverNo.includes(inputFilter.trim()) ||
              person.vehNo.includes(inputFilter.trim())
            )
          )
        ))
        .sort((a, b) => {
          const aIsBroadcast = a.name === 'BroadCast';
          const bIsBroadcast = b.name === 'BroadCast';
          if (aIsBroadcast && !bIsBroadcast) return -1;
          if (!aIsBroadcast && bIsBroadcast) return 1;
          const AisGrouped = a.group !== '-1';
          const BisGrouped = b.group !== '-1';
          if (AisGrouped !== BisGrouped) {
            return AisGrouped ? -1 : 1;
          }
          const affiliateCompare = a.affiliateName.localeCompare(b.affiliateName);
          return affiliateCompare !== 0 ? affiliateCompare : a.name.localeCompare(b.name);
        });

        if(occurance === 'first' && filteredSortedDataArr.length > 0){
          const firstCard = filteredSortedDataArr[0];
          setActiveVehNo(firstCard.cardKey);
          msgIDRef.current = 0;
          indexRef.current = 0;
          activeDriver.current = firstCard.cardKey;
          firstCard.active = true;
        }

        //Updates the state/UI if the filtered list is different
        if(!_.isEqual(driverCardRef.current, filteredSortedDataArr)){
          populateDropdowns(driversArr, vehiclesArr); //updates dropdowns
          driverCardRef.current = [...filteredSortedDataArr]; //Stores filtered list in reference
          //Updates display and active-check lists
          setDriversBlockList(filteredSortedDataArr);
          setDriverBlockListActiveCheck(filteredSortedDataArr);

        }
        //Schedules the next refresh
        if(loadSmartDevicesRef.current){clearTimeout(loadSmartDevicesRef.current);}
        loadSmartDevicesRef.current = setTimeout(async () => {
          await loadSmartDevices('later', selectedAffiliateValue);
        }, 10500);
      }

    } catch(err) {console.log(err);}
  }


  /**
   * Refreshes, sorts, and populates the needed arrays for the drop downs
   * @param {*} driversArr Array of driver objects
   * @param {*} vehiclesArr Array of vehicle objects
   */
  function populateDropdowns (driversArr = [], vehiclesArr = []) {
    try{
      //Finds the slected affiliate and loads the correct dataset
      const selectedAffiliateIDs = getSelectedAffiliateIDs();
      const selectedAffiliateIDSet = new Set(selectedAffiliateIDs.map(item => String(item)));
      const AffiliateDetails = AffiliateData.find(item => parseInt(item.AffiliateID) === getPrimaryAffiliateID());
      const rczZones = (RCZZoneVerticesData && RCZZoneVerticesData.Table && RCZZoneVerticesData.Table.length > 0) ? RCZZoneVerticesData.Table : [];
      const normalZones = (ZoneVerticesData && ZoneVerticesData.Table && ZoneVerticesData.Table.length > 0) ? ZoneVerticesData.Table : [];
      const zones = isAllAffiliatesSelected()
        ? [...rczZones, ...normalZones]
        : (AffiliateDetails ? (parseInt(AffiliateDetails.iTransType) === 2 ? 
          (rczZones.length > 0 ? rczZones : normalZones) : normalZones) 
          : []
        );

      //deduplicates drivers
      
      // H-1 fix: the original code had a broken IIFE where .filter() received a function
      // that returned another function (always truthy), making deduplication completely
      // non-functional. This is the correct Set-based dedup pattern.
      const seen = new Set();
      const uniqueDriversArr = driversArr.filter(driver => {
        const driverKey = `${driver.affiliateID}|${driver.id}|${driver.number}`;
        if (seen.has(driverKey)) return false;
        seen.add(driverKey);
        return true;
      }); 
      
      //Filters and sorts attribute options relevant to the current affiliate.
      let attrSelection = AttributeData ? AttributeData.filter((item,index)=> {return selectedAffiliateIDSet.has(String(item.iAttrATSPID))}) : [];
      let attrOptionsMultiSel = attrSelection && attrSelection.length > 0 ? attrSelection.map((item)=>{
        let dict = {};
        dict.id = item.ID;
        dict.name = isAllAffiliatesSelected() ? `${item.Title} (${getAffiliateName(item.iAttrATSPID)})` : item.Title;
        return dict;
      }).sort((a, b) => a.name.localeCompare(b.name)) : [];

      //sorts drivers
      let driverOptionsMultiSel = uniqueDriversArr.length > 0 ? uniqueDriversArr.map((item)=>{
        let dict = {};
        dict.id = item.id;
        dict.name = item.number + " - " + item.name + (isAllAffiliatesSelected() ? ` (${item.affiliateName})` : "")
        return dict;
      }).sort((a,b)=>{
        const numA = a.name ? parseInt(a.name.split(" - ")[0], 10) : null;
        const numB = b.name ? parseInt(b.name.split(" - ")[0], 10) : null;
        if (numA === null && numB === null) return 0;
        if (numA === null) return 1; // Push a to the end
        if (numB === null) return -1; // Push b to the end
        return numA - numB;
      }) : [];

      //Sorts vehicles
      let vehicleOptionsMultiSel = vehiclesArr.length > 0 ? vehiclesArr.map((item)=>{
        let dict = {};
        dict.id = item.vehID;
        dict.name = item.vehNum + (isAllAffiliatesSelected() ? ` (${item.affiliateName})` : "");
        return dict;
      }).sort((a,b) => {
        const numA = a.name ? parseInt(a.name, 10) : null;
        const numB = b.name ? parseInt(b.name, 10) : null;
        if (numA === null && numB === null) return 0;
        if (numA === null) return 1; // Push a to the end
        if (numB === null) return -1; // Push b to the end
        return numA - numB;
      }) : [];
      let zoneDict = {};
      let zonesArr = [];

      //Finds unique zones and sorts them
      for(const element of zones)
      {
        if(selectedAffiliateIDSet.has(String(element.iZVATSPID))) //props.selectedAffiliates
        {
          let key = element.vName;
          let dict = {};
          if(key in zoneDict)
          {
            let zoneLocations = zoneDict[key];
            let tempDict = {"lat": parseFloat(element.vLat), "lng": parseFloat(element.vLong)};
            zoneLocations.push(tempDict);
            zoneDict[key] = zoneLocations;
            dict.name = key.toUpperCase() + (isAllAffiliatesSelected() ? ` (${getAffiliateName(element.iZVATSPID)})` : "");
            dict.id = key.toUpperCase();
            zonesArr.push(dict);
          }
          else
          {
            let zoneLocations = [];
            let tempDict = {"lat": parseFloat(element.vLat), "lng": parseFloat(element.vLong)};
            zoneLocations.push(tempDict);
            zoneDict[key] = zoneLocations;
            dict.name = key.toUpperCase() + (isAllAffiliatesSelected() ? ` (${getAffiliateName(element.iZVATSPID)})` : "");
            dict.id = key.toUpperCase();
            zonesArr.push(dict);
          }
          
        }
      }

      //Updates 4 multi-select drop downs
      // - Drivers
      // - Vehicles
      // - Zones
      // - Attributes
      const uniqueZonesArr = Array.from(
        new Map(zonesArr.map(item=>[item.name, item])).values()
      );
      const sortedZonesOptionsMultiSel = uniqueZonesArr.sort((a,b)=>a.name.localeCompare(b.name));

      SetDriversFilterMultiSelect({ ...DriversFilterMultiSelect, ...{options: driverOptionsMultiSel,
        selectedValues:[]}}
      );
      SetVehiclesFilterMultiSelect({ ...VehiclesFilterMultiSelect, ...{options: vehicleOptionsMultiSel,
        selectedValues:[]}}
      );
      SetZonesFilterMultiSelect({ ...ZonesFilterMultiSelect, ...{options: sortedZonesOptionsMultiSel,
        selectedValues:[]}}
      );
      SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{options: attrOptionsMultiSel,
        selectedValues:[]}}
      );

    } catch(err){console.log(err);}
  }


   /**
   * Handles selection changes for multi-select dropdowns.
   *
   * This callback updates both the selected values in the central state and the dropdown's UI state
   * when the user selects or deselects items in a multi-select dropdown.
   *
   * Args:
   *   selectedVals: Array of selected values from the dropdown.
   *   key: The string key to update in the central selection object (e.g., "drivers" or "attributes").
   *   multiSelDetails: Object containing dropdown metadata, including the full options list.
   *   multiSelDropdownSetter: setState function for updating the dropdown's UI state.
   *   multiSelChoiceUpdate: setState function for updating selected values in the central tracking state.
   */
  const GenericSelectCallback = (selectedVals, key = "", multiSelDetails = [], multiSelDropdownSetter, multiSelChoiceUpdate) => { //Multiselect attribute selection on change
    try{
      
      const stringVals = selectedVals.map((num) => num.toString()); //Convert selected values to string
      
      //Builds a groupSelected array of full objects with {id, name}
      let groupSelected = [];
      if(multiSelDetails.options) {
        for(const element of multiSelDetails.options)
        {
          if(stringVals.includes(String(element.id)))
          {
            groupSelected.push({id:element.id, name:element.name});
          }
        }
        
        //Stores selected IDs (as strings) in a key-value object
        multiSelChoiceUpdate(prev=>({...prev, [key]: stringVals})); 
        //updates the dropdown's internal state with the actual selected option objects
        multiSelDropdownSetter({ ...multiSelDetails, ...{ selectedValues: groupSelected}});
      }
    }
    catch(err){console.log(err);}
  };


  /**
   * Clears user input and selections for group filters
   */
  function clearGroupDetails () {
    try{
      setGroupNameAssigned(""); //Clears group name input field
      //Clears multi-select drop downs
      setMultiSelectValuesSelected({drivers: [], vehicles: [], zones: [], attributes: []}); 
      SetDriversFilterMultiSelect({ ...DriversFilterMultiSelect, ...{selectedValues:[]}}
      );
      SetVehiclesFilterMultiSelect({ ...VehiclesFilterMultiSelect, ...{selectedValues:[]}}
      );
      SetZonesFilterMultiSelect({ ...ZonesFilterMultiSelect, ...{selectedValues:[]}}
      );
      SetAttributesFilterMultiSelect({ ...AttributesFilterMultiSelect, ...{selectedValues:[]}}
      );
      loadSmartDevices();
    }
    catch(err){console.log(err); loadSmartDevices();}
  }


  /**
   * 
   */
  function handleSendSpecialMsg () {
    try{



    } catch(err){console.log(err);}
  }


  /**
   * 
   */
  // eslint-disable-next-line no-unused-vars
  function refreshSpecialMsgHistory () {
    try{



    } catch(err){console.log(err);}
  }

  /**
   * Handles getting messages back from drivers.
   * CRITICAL-1: Next poll is scheduled exclusively in the finally block via shouldContinuePoll,
   *             preventing overlapping async calls when the API response time exceeds DRIVERMSGTIMER.
   * CRITICAL-2: Uses dedicated cancelMsgRef cancel token, independent of device/popup flows.
   * CRITICAL-3: activeDriver guard in finally prevents a stale poll loop from writing messages
   *             to the pane of a driver the user has already navigated away from.
   * @param {*} index Index of driver card (unused directly — indexRef.current is the live source of truth)
   * @param {*} term  'first' = initial card selection; 'second' = subsequent polling iteration
   */
  async function handleGetDriverMsg(driverKey, term = 'first') {
    let driverKeyForThisCall = '';
    let shouldContinuePoll = false;

    if (term === 'first') {
      pollSessionRef.current += 1;
    }
    const mySession = pollSessionRef.current;

    try{
      let currentDriverCard;
      if (typeof driverKey === 'number') {
        currentDriverCard = driverBlockListActiveCheck[driverKey];
      } else {
        currentDriverCard = driverBlockListActiveCheck.find(card => card.cardKey === driverKey);
      }

      if (!currentDriverCard)
        return;

      const driverNameForThisCall = currentDriverCard.name;
      driverKeyForThisCall = currentDriverCard.cardKey;
      const isAllAffBroadcast = currentDriverCard.affiliateID === 'all';
      const currentAffiliateID = isAllAffBroadcast 
        ? getPrimaryAffiliateID() 
        : parseInt(currentDriverCard.affiliateID || getPrimaryAffiliateID(), 10);

      const toDateVal = 'now';
      let fromDateVal = '';
      let fetchLatestOnly = false;
      
      if(term === 'first'){
        const updateActiveState = prev=>prev.map((driver)=>({
          ...driver,
          active: (driver.cardKey === driverKeyForThisCall ? !driver.active : false),
        }));
        setDriverBlockListActiveCheck(updateActiveState);
        setDriversBlockList(updateActiveState);
        setGivenDateRange('today');
        dateRangeFromRef.current = 'today';
        setCalendarMinMax(prev=>({...prev, selected: ''}));
        fromDateVal = 'today';
      }
      else {
        fromDateVal = dateRangeFromRef.current;
      }
      
      //Checks if message fetch should continue
      if(!currentDriverCard.active || term !== 'first' || currentDriverCard.deviceID  === 'XXXX'){

        //builds body data
        const deviceNumVal = String(currentAffiliateID) + "|" + String(currentDriverCard.deviceID) + String(currentDriverCard.driverNo);

        if(String(msgIDRecordDict.current.deviceRefNum) === deviceNumVal && dateChanged.current === 0){
          fetchLatestOnly = true;
        }
        else{
          setMessagesLoading(true);
          fetchLatestOnly = false;
          msgIDRecordDict.current.deviceRefNum = deviceNumVal;
        }
        let data = {
          atspid: currentAffiliateID,
          affiliateList: isAllAffBroadcast ? getSelectedAffiliateList() : String(currentAffiliateID),
          newMessagePopupLastMessID: parseInt(msgIDRecordDict.current.NewMessageAlertLastMsgID),
          driverID: ("@"+ currentDriverCard.driverNo),
          vehicleID: "-1", //String(currentDriverCard.vehID),
          userID: (allMsgToDriverFlag === null || allMsgToDriverFlag === false)? 'LoginUser' : 'all',
          dispatcherUserID: String(loginData.iUserID),
          deviceID: String(currentDriverCard.deviceID),
          toDate: toDateVal,
          fromDate: fromDateVal,
          tillDate: (fromDateVal.includes("jump") && calendarMinMax.selected !== '' ? new Date(calendarMinMax.selected + " 00:00:00") : new Date())
        };
        if(fetchLatestOnly && parseInt(msgIDRecordDict.current.lastMsgID) > 0)
        {
          data.lastMessID = (term === 'first' ? -1 : msgIDRecordDict.current.lastMsgID);
        }
        //Makes API post call using the dedicated message-polling cancel token (CRITICAL-2)
        cancelMsgRef.current = APICom.GenerateSource();
        const loadMsgResponse = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/LoadGeneralMessages", "post", {}, data, cancelMsgRef.current);
        
        // If the selection session changed during the API fetch, discard and exit!
        if (mySession !== pollSessionRef.current) {
          return;
        }

        //successful response
        if(loadMsgResponse && loadMsgResponse.error.length === 0 ) {
          dateChanged.current = 0;
          setPollingError(''); // M-1: clear any prior error on first successful response
          const lastIndex = (loadMsgResponse.data.length - 1);
          msgIDRecordDict.current.lastMsgID = parseInt(loadMsgResponse.data[lastIndex].MessageID) > -1 ? loadMsgResponse.data[lastIndex].MessageID : msgIDRecordDict.current.lastMsgID;
          if(parseInt(loadMsgResponse.data[0].NewMessageAlertLastMessID) > -1 && 
            loadMsgResponse.data[0].NewMessageAlertLastMessID !== msgIDRecordDict.current.NewMessageAlertLastMsgID
          )
          {
            msgIDRecordDict.current.NewMessageAlertLastMsgID = loadMsgResponse.data[0].NewMessageAlertLastMessID;
          }
          //Displays message and triggers blink notification
          if(loadMsgResponse.data[0].msgString !== '') {
            // Build the alert set: prefer the NewMessageAlerts list (array of {VehicleNo, AffiliateID, MessageID})
            // which contains ALL drivers that sent messages in this poll window.
            // Fall back to the legacy scalar field for backward compatibility with older API versions.
            const newAlerts = (loadMsgResponse.data[0].NewMessageAlerts?.length > 0)
              ? loadMsgResponse.data[0].NewMessageAlerts
              : (loadMsgResponse.data[0].NewMessageAlertVehNo
                  ? [{ VehicleNo: loadMsgResponse.data[0].NewMessageAlertVehNo,
                        AffiliateID: loadMsgResponse.data[0].NewMessageAlertAffiliateID,
                        MessageID: loadMsgResponse.data[0].NewMessageAlertLastMessID }]
                  : []);

            if(newAlerts.length > 0){
              // C-2 fix: use driversBlockListRef.current (always live) instead of driversBlockList
              // (closure-captured, up to 2000ms stale when this code runs inside a setTimeout callback).
              const currentDriverList = driversBlockListRef.current;

              // Identify which alerts matched a visible card and which did not.
              const matchedAlerts = [];
              const unmatchedAlerts = [];
              newAlerts.forEach(alert => {
                // Do not process notifications for broadcast messages. Drivers cannot send broadcasts.
                // Any broadcast alert is simply the database echoing back the dispatcher's own message.
                if (normalizeVehNo(alert.VehicleNo) === "xxxx") {
                  return;
                }

                const targetAffID = alert.AffiliateID && alert.AffiliateID !== "-1"
                  ? String(alert.AffiliateID)
                  : String(currentAffiliateID);
                const notifiedDriver = currentDriverList.find(item => {
                  const itemAff = String(item.affiliateID);
                  const isMatchAff = itemAff === "all" || targetAffID === "all" || itemAff === targetAffID;
                  return normalizeVehNo(item.vehNo) === normalizeVehNo(alert.VehicleNo) && isMatchAff;
                });
                if(notifiedDriver){
                  matchedAlerts.push({ alert, notifiedDriver });
                } else {
                  unmatchedAlerts.push(alert);
                }
              });

              // Guard: Only turn on header notification if there are unmatched alerts or
              // matched alerts for background (non-active) drivers. Active driver alerts are read immediately.
              const hasOtherAlerts = unmatchedAlerts.length > 0 ||
                matchedAlerts.some(({ notifiedDriver }) => notifiedDriver.cardKey !== activeDriver.current);
              if (hasOtherAlerts) {
                setMessagingHeaderNotification(true);
              }

              // H-1 fix: record side effects (setPendingDriverMessage, setBlinkRecentMsg,
              // setDocTitle) OUTSIDE the setDriversBlockList functional update. Functional
              // updates must be pure — React may call them more than once (StrictMode).
              matchedAlerts.forEach(({ alert, notifiedDriver }) => {
                if(notifiedDriver.cardKey !== activeDriver.current){
                  setPendingDriverMessage({
                    affiliateID: notifiedDriver.affiliateID,
                    affiliateName: notifiedDriver.affiliateName,
                    vehNo: alert.VehicleNo,
                    driverNo: notifiedDriver?.driverNo,
                    messageID: alert.MessageID
                  });
                }
              });

              if(matchedAlerts.length > 0){
                const lastMatch = matchedAlerts[matchedAlerts.length - 1];
                setBlinkRecentMsg(
                  (dispatcherSend.current
                    ? loadMsgResponse.data[0].msgFrom + " ➞ " + lastMatch.notifiedDriver.name + " (" + lastMatch.notifiedDriver.driverNo + "): "
                    : lastMatch.notifiedDriver.name + " (" + lastMatch.notifiedDriver.driverNo + "): ")
                  + loadMsgResponse.data[0].msgString
                );
                dispatcherSend.current = false;
                setDocTitle(`Driver ${lastMatch.notifiedDriver.driverNo}: New Msg`);
              }

              // Queue unmatched alerts locally to avoid database/network overload from stuck cursors.
              if (unmatchedAlerts.length > 0) {
                addUnmatchedAlerts(unmatchedAlerts);
              }

              // Always advance the API alert cursor to the absolute maximum MessageID of all alerts received.
              // This ensures that the next poll only fetches NEW alerts (MessageID > maxMsgID),
              // preventing the database from scanning and returning duplicate alerts repeatedly.
              const maxMsgID = newAlerts.reduce((max, alert) => Math.max(max, parseInt(alert.MessageID) || 0), 0);
              if (maxMsgID > parseInt(msgIDRecordDict.current.NewMessageAlertLastMsgID)) {
                msgIDRecordDict.current.NewMessageAlertLastMsgID = String(maxMsgID);
              }

              // Pure functional update — no side effects. L-2 fix: use activeDriver.current
              // (a ref, always current) instead of activeVehNo (state, stale in this closure).
              const matchedCardKeys = new Set(matchedAlerts.map(({ notifiedDriver }) => notifiedDriver.cardKey));
              setDriversBlockList(prev => prev.map(item =>
                matchedCardKeys.has(item.cardKey)
                  ? { ...item, blink: item.cardKey !== activeDriver.current }
                  : item
              ));
            }
            if(parseInt(loadMsgResponse.data[0].MessageID) > -1){
                if(loadMsgResponse.data[0].msgString !== ''){
                  setTimeout(() => {
                    setDriverCardMsgList(prev=>{
                      if (activeDriver.current !== driverKeyForThisCall){
                        return prev;
                      }

                      const isForSameDriver = driverKeyForThisCall === prev.cardKey;

                      const baseMsgList = isForSameDriver ? prev.msgList : [];

                      const existingMsgStrings = new Set(baseMsgList.map(m => `${m.msgString}|${m.msgTime}`));

                      const newMsg = loadMsgResponse.data.filter(
                        m => !existingMsgStrings.has(`${m.msgString}|${m.msgTime}`)
                    );

                      const oldMsg = [...existingMsgStrings].filter(
                        m => !loadMsgResponse.data.some(m2 => `${m2.msgString}|${m2.msgTime}` === m)
                    );
                    
                    
                      // If there are no new messages, return the previous state to avoid a re-render.
                      if (newMsg.length === 0 && oldMsg.length === 0) {
                        return prev;
                      }
                      else if (newMsg.length > 0) {
                        return {
                          driverName: driverNameForThisCall,
                          cardKey: driverKeyForThisCall,
                          msgList: [...baseMsgList, ...newMsg].sort((a, b) => new Date(a.msgTime) - new Date(b.msgTime))
                        };
                      }
                      else if (oldMsg.length > 0) {                        
                        return{
                          driverName: driverNameForThisCall,
                          cardKey: driverKeyForThisCall,
                          msgList: [...loadMsgResponse.data].sort((a, b) => new Date(a.msgTime) - new Date(b.msgTime))
                        }
                      }
                    });
                    
                  }, 0);
                }
            }
          }
          // Successful response — continue polling regardless of whether messages were present.
          // (CRITICAL-1: scheduling moved to finally block below)
          shouldContinuePoll = true;
        }
        else
        { // API error or cancelled — reset state and always retry.
          // C-1 fix: the original code only set shouldContinuePoll=true for non-active
          // (broadcast) drivers. For active drivers, polling stopped permanently on any
          // network error with no indication to the dispatcher. The finally-block guard
          // (activeDriver.current === driverKeyForThisCall) already prevents stale-driver
          // retries, so unconditionally retrying here is safe.
          msgIDRecordDict.current.lastMsgID = -1;
          setDriverCardMsgList([]);
          // M-1: surface the retry state so the dispatcher can see polling is recovering.
          setPollingError('Connection issue — retrying…');
          shouldContinuePoll = true;
        }
      }
      else {
        // Active driver on first load: stop here. The activeVehNo effect will re-trigger when ready.
        if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
        setDriverCardMsgList([]);
      }
    } catch(err){console.log(err); setDriverCardMsgList([]);}
    finally{
        setMessagesLoading(false);
        // CRITICAL-1: Schedule the next poll exactly once, here, after the current call fully completes.
        // CRITICAL-3: Guard — if the user switched to a different driver while we were awaiting,
        //             activeDriver.current will no longer match driverKeyForThisCall, so we skip
        //             re-scheduling and let the new card's own polling chain take over.
        if(shouldContinuePoll && mySession === pollSessionRef.current && (driverKeyForThisCall === '' || activeDriver.current === driverKeyForThisCall)){
          if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
          loadDriverMsgRef.current = setTimeout(async () => {
            await handleGetDriverMsg(driverKeyForThisCall, 'second');
          }, DRIVERMSGTIMER);
        }
    }
  }

  async function handlePopupView (show, groupDetails, groupIndex = 0) {
    try{
      if(show){
        const spanElement = spanPopupRef.current[groupIndex];
        if(spanElement){
          cancelPopupRef.current = APICom.GenerateSource(); // Dedicated cancel token for popup (CRITICAL-2)
          const rect = spanElement.getBoundingClientRect();
          
          const groupMembersData = {
            'ATSPID': parseInt(groupDetails.affiliateID || getPrimaryAffiliateID(), 10),
            'GroupID': parseInt(groupDetails.deviceID)
          };
          const groupListResp = await APICom.fetchData("ReservationCoreURL","api/ParatransitCT/LoadGroupDevicesList", "post", {}, groupMembersData, cancelPopupRef.current);

          if(groupListResp && groupListResp.error.length === 0 && Array.isArray(groupListResp.data) && groupListResp.data.length > 0){
            setPopupDriversList(groupListResp.data);
          }
          setPopupPos({
            top: rect.top + 20,
            left: rect.right + window.scrollX
          });
          setShowPopup({show: true, groupDict: groupDetails});
        }
      }
      else{
        setPopupDriversList([]);
        setShowPopup({show: false, groupDict: {}});
        setPopupPos({ top: 0, left: 0 });
      }
    } catch (err) {console.log(err);}
  }

  async function handleDateRangeChange (e) {
    try{
      setMessagesLoading(true);
      const newDate = e.target.value;
      setGivenDateRange(newDate); 
      dateRangeFromRef.current = newDate;
      setDriverCardMsgList([]);
      if(newDate === 'jump to specific date')
      {
        const SystemDateTime = await DateTimeUtils.getCurrentSystemDateTime();
        const [month, day, year] = (SystemDateTime.split(" ")[0]?.split("/") || ['','','']);
        const systemDateFormatted = (month !== '' ? (year + "-" + month + "-" + day) : null);
        if(systemDateFormatted){
          const threeMonthBound = new Date(systemDateFormatted + " 00:00:00");
          threeMonthBound.setMonth(threeMonthBound.getMonth() - 3);
          const minDateFinal = threeMonthBound.toISOString().split('T')[0];
          const maxDateFinal = systemDateFormatted;
          const rect = dateSelectRef.current.getBoundingClientRect();
          setCalendarMinMax(prev=>({...prev, min: minDateFinal, max: maxDateFinal}));
          setCalendarPos({
            top: rect.top + 40,
            left: rect.right + window.scrollX - 160
          });
          setShowCalendar(true);
          setTimeout(() => {
            if(calendarInputRef.current){
              calendarInputRef.current.focus();
            }
          }, 200);

        }
        else{
          setShowCalendar(false);
        }
      }
      else{
        dateChanged.current = 1;
        setCalendarMinMax(prev=>({...prev, selected: ''}));
        setShowCalendar(false);
        
      }
      
      
    } catch(err){console.log(err);}
  }

  function dateCheck(e, type = '') {
    try {
      const selectedDate = new Date(e.target.value + " 00:00:00");
      const minDate = new Date(calendarMinMax.min + " 00:00:00");
      const maxDate = new Date(calendarMinMax.max + " 00:00:00");
      const minDateForm = `${String(minDate.getMonth() + 1).padStart(2, '0')}/${String(minDate.getDate()).padStart(2, '0')}/${minDate.getFullYear()}`;
      const maxDateForm = `${String(maxDate.getMonth() + 1).padStart(2, '0')}/${String(maxDate.getDate()).padStart(2, '0')}/${maxDate.getFullYear()}`;
      if(selectedDate > maxDate){
        setCalendarMinMax(prev=>({...prev, selected: ''}));
        if(calendarInputRef.current){
          calendarInputRef.current.style.border = '2px solid red';
        }
        setWarningMsg(<p className="m-0 small fw-normal">{'Min: ' + minDateForm} <br/> {'Max: ' + maxDateForm}</p>)
      }
      else if(selectedDate < minDate){
        //setCalendarMinMax(prev=>({...prev, selected: ''}));
        if(calendarInputRef.current){
          calendarInputRef.current.style.border = '2px solid red';
        }
        setWarningMsg(<p className="m-0 small fw-normal">{'Min: ' + minDateForm} <br/> {'Max: ' + maxDateForm}</p>)
      }
      else{
        setWarningMsg("");
        setCalendarMinMax(prev=>({...prev, selected: e.target.value}));
        dateChanged.current = 1;
        if(type === 'key'){
          setShowCalendar(false);
        }
      }
  
        
        
    } catch (err) {
      console.log(err);
    }
  }

  function resetCreateScheduleFields () {
    try{
      setCreateSchDetails({name: '', time: '', extra: '', days: {mon: false, tue: false, wed: false, thurs: false, fri: false, sat: false, sun: false}});
      setAddSchToggleOptions({recurring: false, popup: false, active: true});
      setShowAddScheduleDisplay(false);
      setMultiSelectValuesSelected({drivers: [], vehicles: [], zones: [], attributes: []});
      SetDriversFilterMultiSelect({ ...DriversFilterMultiSelect, ...{selectedValues:[]}});
    } catch(err){console.log(err);}
  }
  

  return (
    <>
      {isLoading && (
        //////////////////////////
        // loading page spinner //
        //////////////////////////
        <span
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)', // light overlay
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
          }}
        >
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            aria-busy= {isLoading}
            style={{ marginBottom: '3px' }}
          />
          
          <label style={{marginLeft: "10px",fontSize: "larger",marginBottom: "5px"}}><output>Please wait, Loading Data....</output></label>
        </span>
      )}
      
      { //////////////////////
        // "header" on page //
        //////////////////////
        <Row className="m-0 px-1" style={{backgroundColor:"#2e3942", height:"38px", maxHeight:"38px"}}>
          <Col className="d-flex my-auto align-items-center">
            <img src={ITCLogo} className='ITCLogo page-header-logo user-select-none m-0' style={{maxWidth:"200px", maxHeight:"30px"}} alt="ITCurves" />
            <p className="fw-bold text-white text-center text-nowrap overflow-hidden h3 user-select-none flex-grow-1" style={{margin:"0"}}>
              {'Driver MDT Messaging 2.0'}
            </p>
          </Col>
        </Row>
      }


      <Row className="m-0 fw-normal user-select-none" style={{height:`calc(100vh - 83px)`}}>
        <Col xs={3}>
          <Row className="m-0" style={{maxHeight:"125px"}}>
            <Col className="border-bottom" style={{height: '125px', maxHeight:"125px"}}>
              {
                /////////////////////////
                // Affiliate Drop Down //
                /////////////////////////
                <select id="affiliateDrop" style={{textOverflow:"ellipsis", borderRadius:"5px", maxHeight:"30px", height:"30px"}} value={selectedAff}
                  onChange={(e)=>{
                    affiliateSelectionInitializedRef.current = true;
                    setSelectedAff(e.target.value);
                  }} 
                  className='text-center w-100 overflow-hidden callAgentInputStyle my-1' tabIndex={-1}
                >
                  {affiliateDropDownHTML}
                </select>
              }

              {
                ////////////////////////////
                // Driver Active 'Button' //
                ////////////////////////////
                <span className={`${driverStatusFlag === 'Active' ? 'text-white bg-dark' : ''} small px-2 mt-1 py-1`} onClick={()=>{
                    setDriverStatusFlag('Active'); 
                  if(activeVehNo){
                    setDriverCardMsgList([]);
                      setDriverBlockListActiveCheck(prev =>
                        prev.map((driver, ind) => {
                        if(driver && driver.deviceID === 'XXXX'){
                          indexRef.current = ind;
                          activeDriver.current = driver.cardKey;
                          return {...driver, active: true};
                        }
                        else if (driver) {
                          return {...driver, active: false};
                        }
                        return driver;
                      })
                      );
                      activateFirstBroadcast(driverBlockListActiveCheck);
                      if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
                      setDriverCardMsgList([]);
                  }
                  }} 
                  style={{backgroundColor: `${driverStatusFlag === 'Active' ? '' : '#e6eef1'}`, 
                  color: `${driverStatusFlag === 'Active' ? '' : 'black'}`, cursor:'pointer', borderRadius: "10px"
                }}
                  >
                  {"Online"}
                </span>
              }
              
              {
                ///////////////////////////////
                // Driver Inactive 'Button' //
                //////////////////////////////
                <span className={`${driverStatusFlag === 'Inactive' ? 'text-white bg-dark' : ''} small ms-2 px-2 py-1`} onClick={()=>{
                    setDriverStatusFlag('Inactive');
                  if(activeVehNo){
                    setDriverCardMsgList([]);
                    setDriverBlockListActiveCheck(prev =>
                      prev.map((driver, ind) => {
                      if(driver && driver.deviceID === 'XXXX'){
                        indexRef.current = ind;
                        activeDriver.current = driver.cardKey;
                        return {...driver, active: true};
                      }
                      else if (driver) {
                        return {...driver, active: false};
                      }
                      return driver;
                    })
                    );
                      activateFirstBroadcast(driverBlockListActiveCheck);
                      if(loadDriverMsgRef.current){clearTimeout(loadDriverMsgRef.current);}
                    }
                  
                  }} 
                  style={{backgroundColor: `${driverStatusFlag === 'Inactive' ? '' : '#e6eef1'}`, 
                    color: `${driverStatusFlag === 'Inactive' ? '' : 'black'}`, cursor:'pointer', borderRadius: "10px"
                  }}
                  >
                  {"Offline"}
                </span>
              }

              
              <span className="d-inline-block ms-2 my-auto">
                {
                  ////////////////////
                  // "Create Group" //
                  ////////////////////
                  <span className="my-auto" style={{cursor:"pointer"}} title={(isAllAffiliatesSelected() ? "Select one affiliate to create a group" : (createGroupFlag ? "Cancel Group" : "Create Group"))} 
                    onClick={(e)=>{
                      if(isAllAffiliatesSelected()){
                        return;
                      }
                      setCreateGroupFlag(!createGroupFlag); 
                      if(!createGroupFlag){
                        clearTimeout(loadSmartDevicesRef.current);
                        setTimeout(() => {
                          groupNameFieldRef.current.focus();
                        }, 200);
                      }
                      else{
                        clearGroupDetails();
                      }
                    }}
                  >
                    <Icon className={`${createGroupFlag ? 'MessagingChatIconActive' : 'MessagingChatIconInActive'} my-auto`} 
                      style={{width:"25px", height:"25px", opacity: isAllAffiliatesSelected() ? 0.45 : 1}} 
                      icon={(!createGroupFlag ? 'ic:baseline-group-add' : 'ic:baseline-group-off')}
                    /> 
                    
                  </span>
                  
                }
                <>
                  <span className="d-inline-block ms-2 my-auto" style={{cursor:"pointer"}} title={("Schedule & View Messages")} 
                      onClick={(e) => { 
                        if(WebMRMS_URL.current !== "" && loginData.vUserName !== "" && loginData.vPassword !== "")
                        {
                          let url = WebMRMS_URL.current + "WebMRMS/DSPC/SmartDeviceSchedulingList.aspx?hfSDIID=-1&username="+ loginData.vUserName +"&pass=" + loginData.vPassword +"";
                          setScheduleDialog({Display:true, URL:url});
                          //const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
                          //if (newWindow) newWindow.opener = null;
                        }
                      }
                    }
                  >
                    {/* Your new span content */}
                    <Icon className={`my-auto`} 
                      style={{width:"25px", height:"25px"}} 
                      icon={('material-symbols-light:schedule-outline')}
                    /> 
                  </span>
                </>
                
                {createGroupFlag ? 
                  //////////////////////////////////
                  // "Create Group" button pop up //
                  //////////////////////////////////
                  <span className="position-absolute rounded text-center bg-white border border-secondary my-auto"
                    style={{width:'350px', maxWidth:'350px', height:'150px', maxHeight:'200px', top:'10%', zIndex: 1000}}
                  >
                    <p className='m-0 ms-1 d-block user-select-none my-auto fw-bold small text-start text-nowrap overflow-hidden' 
                      style={{minWidth:"70px", textOverflow:'ellipsis'}}
                    >
                      {'Group Name:'}
                    </p>
                    <input type={"text"} ref={groupNameFieldRef} className="text-nowrap p-0 px-1 callAgentInputStyle" style={{maxHeight:"30px", height:"30px"}} 
                      onChange={(e)=>{setGroupNameAssigned(e.target.value);}} value={groupNameAssigned}
                    />
                    
                    {/* <span className="d-flex mt-1" style={{height:"20px", width: '100%'}}>
                      <p className='m-0 ms-1 d-block user-select-none w-100 my-auto fw-bold small text-start text-nowrap overflow-hidden' 
                        style={{minWidth:"120px", textOverflow:'ellipsis'}}
                      >
                        {'Group By:'}
                      </p>
                    </span>
                    <select style={{textOverflow:"ellipsis", borderRadius:"5px", maxHeight:"30px", height:"30px", width: '189px'}} value={groupByFilter}
                      onChange={(e)=>{setGroupByFilter(e.target.value);}} 
                      className='text-center overflow-hidden callAgentInputStyle' tabIndex={-1}
                    >
                      <option value={"Drivers"}>{"Drivers"}</option>
                      <option value={"Vehicles"}>{"Vehicles"}</option>
                      <option value={"Zones"}>{"Zones"}</option>
                      <option value={"Attributes"}>{"Attributes"}</option>
                    </select> */ //ABOVE IS FOR REMOVAL OF GROUP BY FOR GROUP CREATION - LEFT FOR FUTURE USE
                    }


                    <span className="d-flex mt-1" style={{height:"20px", width: '100%'}}>
                      <p className='m-0 ms-1 d-block user-select-none w-100 my-auto fw-bold small text-start text-nowrap overflow-hidden' 
                        style={{minWidth:"120px", textOverflow:'ellipsis'}}
                      >
                        {groupByFilter + ":"}
                      </p>
                      {/* <p className='m-0 ms-1 d-block user-select-none w-100 my-auto fw-bold small text-start text-nowrap overflow-hidden' 
                        style={{minWidth:"120px", textOverflow:'ellipsis'}}
                      >
                        {'Vehicles:'}
                      </p> */}
                    </span>
                    <span className="d-flex justify-content-center text-center w-100" style={{height:"40px"}}>
                      <MultiSelectDropdown options={filterOptionsMap[groupByFilter].options} disablePreSelectedValues={true} 
                        SelectionChangeCallback={(e)=>{
                          GenericSelectCallback(e, groupByFilter.toLowerCase(), filterOptionsMap[groupByFilter].options, 
                            filterOptionsMap[groupByFilter].setOptions, setMultiSelectValuesSelected
                          );
                        }} FireSelectEventOnEveryItemChange={true}
                      />
                      
                    </span>
                    
                    <span className="my-auto d-flex text-end justify-content-end mt-1">
                      <span className="my-auto d-inline-flex" style={{cursor:"pointer"}} title={'Create'} 
                        onClick={addGroupOfDrivers}
                      >
                        <Icon className={`text-success my-auto`} style={{width:"20px", height:"20px"}} 
                          icon={"material-symbols:check-rounded"}
                        /> 
                        
                      </span>
                      <span className="my-auto ms-2 me-1 d-inline-flex" style={{cursor:"pointer"}} title={"Cancel"} 
                        onClick={(e)=>{
                          setCreateGroupFlag(false); 
                          clearGroupDetails();
                        }}
                      >
                        <Icon className={`text-danger my-auto`} 
                          style={{width:"20px", height:"20px"}} 
                          icon={"codex:cross"}
                        /> 
                    
                      </span>
                    </span>
                  </span> 
                : ""}
              </span>
              <label className="d-flex">
                <input id='allMessageCheck' type='checkbox' className="d-inline-flex" checked={allMsgToDriverFlag} style={{cursor:'pointer'}} readOnly={false}
                  onChange={(e) => { setAllMsgToDriverFlag(e.target.checked); dateChanged.current = 1; }} 
                />
                <p className='m-0 ms-1 d-inline-block user-select-none w-100 fw-normal small text-start text-nowrap overflow-hidden' 
                  style={{minWidth:"120px", textOverflow:'ellipsis'}}
                >
                  {'All Messages to Driver'}
                </p>
              </label>
              
              <input id='driverSearch' type={"text"} className="text-nowrap p-0 px-1 my-1 callAgentInputStyle w-100" style={{maxHeight:"30px", height:"30px"}} 
                placeholder="Search for driver..." onChange={handleFilterDrivers} value={driverFilterInput}
              />
            </Col>
          </Row>
          <Row className="m-0 mt-1">
            <Col className="overflow-auto callAgentSummaryScroller" style={{height:`calc(100vh - 210px)`}}>
              {driversBlockList.length > 0 ? driversBlockList
                .map((item, index)=>{
                  const id = item.id === -1 ? '' : ('\nNo.: ' + item.driverNo);
                  const VEHNO = item.vehID === -1 ? '' : (", Veh: " + item.vehNo + " (" + item.vehType + ")"); 
                  const DriverName = item.name;
                  
                  // "One" mode: single-select only, toggle and reset others (blink style: 'fancy-blink')
                  return(
                    <Button variant={item.blink ? 'warning' : 'transparent'} key={item.cardKey || index} active={item.cardKey === activeVehNo} 
                      className={`border-0 rounded raised-button mt-1 w-100 MessagingDriverCardHover text-start d-flex 
                        ${item.cardKey === activeVehNo ? 'MessagingDriverCardActive':''}`
                      }
                      onClick={()=> {
                        indexRef.current = index;
                        // CRITICAL-3: Update activeDriver.current synchronously BEFORE setActiveVehNo.
                        activeDriver.current = item.cardKey;
                        if(messageInputRef.current){messageInputRef.current.focus();}
                        setActiveVehNo(prev => {
                          if(prev === item.cardKey){
                            return prev;
                          }
                          else {
                            setDriverCardMsgList([]);
                            return item.cardKey;
                          }
                        });
                      }}
                      title={(item.group === '-1' ? (DriverName + id + VEHNO + "\nAffiliate: " + item.affiliateName) : item.affiliateName)}
                    >
                      {item.group !== '-1' ? 
                        <span className="my-auto d-flex" title={DriverName}>
                          <Icon className={`text-dark my-auto text-start d-inline-flex`} style={{width:"20px", height:"20px", minHeight:'20px', minWidth: '20px'}} 
                            icon={(item.name !== 'BroadCast' ? "el:group" : 'mage:megaphone-a-fill')}
                          /> 
                        </span>
                      : ""}
                      <p className={`m-0 ms-1 ${item.group !== '-1' ? 'd-inline-block flex-grow-1' : 'd-block flex-grow-1'} 
                          user-select-none my-auto fw-bold small text-start text-nowrap overflow-hidden`
                        } title={(item.group === '-1' ? '' : DriverName)}
                        style={{minWidth:(item.group !== '-1' ? '' : "70px"), width: (item.group !== '-1' ? '180px' : ""), textOverflow:'ellipsis'}}
                      >
                        {item.group === '-1'?
                          <>
                              <img src={'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp'} 
                                className={`rounded-circle float-start me-2 mt-1 border ${item.activeDriver? 'border-success' : 'border-danger'} 
                                  MessagingBorderWidthThickness`} 
                                style={{height:"35px", width:"35px"}} 
                                onError={(e)=>{
                                  e.target.src = 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp';
                                }}
                                alt={'Profile'}
                              /> 
                              
                              <span className="d-block overflow-hidden text-nowrap" style={{ textOverflow: 'ellipsis' }}>
                                {DriverName + " (" + item.driverNo + ")"}
                              </span>
                              <span className="d-inline-block overflow-hidden text-nowrap px-1"
                                style={{ textOverflow: 'ellipsis', marginLeft:'40px', maxWidth:'160px', borderRadius:'4px', backgroundColor:item.affiliateColor, color:'#fff', fontSize:'10px', lineHeight:'14px'}}
                              >
                                {item.affiliateName}
                              </span>
                              <span className="d-block overflow-hidden text-nowrap my-auto" style={{ textOverflow: 'ellipsis', marginLeft:'40px'}}>
                                <Icon className={`text-start d-inline-block me-1 mb-1`} style={{width:"20px", height:"20px", color: (item.blink ? 'black' : 'orange')}} 
                                  icon={"mdi:taxi"}
                                />  
                                {item.vehNo + " (" + item.vehType + ")"}
                              </span>
                          </>
                        : (
                          <>
                            <span className="d-block overflow-hidden text-nowrap" style={{ textOverflow: 'ellipsis' }}>{DriverName}</span>
                            <span className="d-inline-block overflow-hidden text-nowrap px-1"
                              style={{ textOverflow: 'ellipsis', maxWidth:'150px', borderRadius:'4px', backgroundColor:item.affiliateColor, color:'#fff', fontSize:'10px', lineHeight:'14px'}}
                            >
                              {item.affiliateName}
                            </span>
                          </>
                        )}
                      </p>
                      {item.group !== '-1' && item.name !== 'BroadCast' ? 
                        <>
                          <span className={`my-auto d-inline-flex m-0 ms-2 me-1 float-end rounded-circle`}
                            title={"Delete Group"} onClick={(e)=>{deleteSelectedGroup(item);}}
                          >
                            <Icon className={`text-danger my-auto`} style={{width:"25px", height:"25px"}} icon={"codex:cross"}/>
                          </span>
                          
                          {/*
                            <span className={`my-auto d-inline-flex me-1 p-1 float-end rounded-circle`}
                              title={"Edit Group"} onClick={(e)=>{editSelectedGroup(item);}}
                            >
                              <Icon className={`text-secondary my-auto`} style={{width:"20px", height:"20px"}} icon={"mdi:gear-outline"}/>
                            </span> 
                          */ //ABOVE IS FOR REMOVAL OF GROUP EDIT - LEFT FOR FUTURE USE
                          }
                          
                          <span className={`my-auto d-inline-flex p-1 float-end rounded-circle`} ref={(el)=>(spanPopupRef.current[index] = el)}
                            onClick={(e)=>{handlePopupView(true, item, index);}} onMouseLeave={(e)=>{
                              setTimeout(() => {
                                handlePopupView(false, item, index);
                              }, 200);
                            }}
                          >
                            <Icon className={`text-info my-auto`} style={{width:"20px", height:"20px"}} icon={"material-symbols:info-outline-rounded"}/>
                          </span>
                        </>
                        
                      : ""}
                    </Button>
                  );
                }) 
              : ''}
              {showPopup.show && popupDriversList.length > 0 ? 
                <span className="position-absolute p-1 pb-2 text-start rounded-bottom bg-light raised-button" 
                  style={{top:popupPos.top, left:popupPos.left, zIndex: 1000}}
                >
                  {popupDriversList.map((item, index)=> {
                    return(
                      <p key={index} className="m-0 px-1 d-flex small text-nowrap" style={{height:'20px', width: 'auto'}}>
                        {'◆ ' } <b>{item.DriverNo}</b> {/* + item.FirstName + ' ' + item.LastName + ' (' {') '} */}
                        <span className="my-auto d-inline-flex ms-1" style={{cursor:"pointer"}}>
                          {/* <Icon className={`text-warning my-auto`} style={{width:"20px", height:"20px"}} 
                            icon={"mdi:taxi"}
                          />  */}
                          {/* {" " + " (SEDAN)"} */}
                        </span>
                      </p>
                    );
                  })}
                </span>
              :""}
            </Col>
          </Row>
          
        </Col>
        <Col xs={9} className="p-0" style={{height:`calc(100vh - 83px)`}} ref={msgListRef}>
          <select className='text-center mx-auto p-1 callAgentInputStyle raised-button messagingDateRangeSelect position-absolute justify-content-center d-flex' 
            style={{width: '173px', minWidth:"173px", maxHeight:"30px", height:"30px", zIndex:(openMsgScheduleView ? '' : 9999)}} value={givenDateRange}
            onChange={handleDateRangeChange} onClick={(e)=>{
              if(e.target.value === givenDateRange && givenDateRange === 'jump to specific date'){
                setShowCalendar(true); 
                // setTimeout(() => {
                //   if(calendarInputRef.current){
                //     calendarInputRef.current.focus();
                //   }
                // }, 200);
              }
            }} 
            ref={dateSelectRef}
          >
            <option value={"today"}>{"Today"}</option>
            <option value={"yesterday"}>{"Yesterday"}</option>
            <option value={"last week"}>{"Last week"}</option>
            <option value={"last month"}>{"Last month"}</option>
            <option value={"jump to specific date"}>
              {(calendarMinMax.selected && calendarMinMax.selected !== '' && warningMsg === '' ? 
                (calendarMinMax.selected.split("-")[1] + "/" + calendarMinMax.selected.split("-")[2] + "/" + calendarMinMax.selected.split("-")[0]) 
                : 
                "Go to a specific date"
              )}
            </option>
          </select>
          {showCalendar ? 
            <>
              <span className="d-block user-select-none bg-white rounded raised-button text-center my-auto position-absolute p-1" 
                style={{top:calendarPos.top, left:calendarPos.left, zIndex: 1000, width: '150px'}} ref={calendarSpanRef}
              >
                <input type="date" autoComplete="new_pass" ref={calendarInputRef} value={calendarMinMax.selected}
                  onChange={(e)=>{setCalendarMinMax(prev=>({...prev, selected: e.target.value}));}} 
                  onKeyDown={(e)=>{
                    if(e.key === 'Enter' && e.target.value !== ''){
                      e.preventDefault();
                      setCalendarMinMax(prev=>({...prev, selected: e.target.value}));
                      dateCheck(e, 'key');
                    } 
                  }} onBlur={(e)=>{if(e.target.value !== ''){setCalendarMinMax(prev=>({...prev, selected: e.target.value}));dateCheck(e, 'key');}}}
                  className="m-0 px-1 text-center callAgentInputStyle" min={calendarMinMax.min} max={calendarMinMax.max}
                  style={{minWidth:"120px", maxHeight:"30px", height:"30px"}} 
                />
                <span className="my-auto d-block w-100 text-center text-danger mt-1">
                  {warningMsg}
                </span>
              </span>
            </>
          : ""}
          <MainContainer className="">
            <ChatContainer>
              {driversBlockList.length > 0 ? ( () => {
                const driverWithBlink = driversBlockList.find(card=>card.blink);
                  return driverWithBlink && blinkRecentMsg !== '' ? 
                  (
                    <ConversationHeader key={driverWithBlink.id}>
                      <ConversationHeader.Content
                        userName="Recent:"
                        info={blinkRecentMsg}
                      />
                    </ConversationHeader>
                  ) : <ConversationHeader key="noBlinks"></ConversationHeader>;
                })
              : <ConversationHeader key="noBlinks"></ConversationHeader>}
              
              {/* M-1: polling error banner — auto-clears on next successful response */}
              {pollingError && (
                <div style={{
                  background: '#fef3c7', color: '#92400e', fontSize: '0.75rem',
                  padding: '3px 8px', borderRadius: '4px', marginBottom: '4px',
                  display: 'flex', alignItems: 'center', gap: '5px'
                }}>
                  <span>⚠</span><span>{pollingError}</span>
                </div>
              )}
              
              <MessageList className="mt-4">
                { 
                messagesLoading ? (
                  <MessageList.Content>
                  <span
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(255, 255, 255, 0.7)', // light overlay
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      zIndex: 999,
                    }}
                  >
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      aria-busy= {isLoading}
                      style={{ marginBottom: '3px' }}
                    />
                      <label style={{marginLeft: "10px",fontSize: "larger",marginBottom: "5px"}}><output>Please wait, Loading Data....</output></label>
                  </span>
                  </MessageList.Content>
                ) : driverCardMsgList?.msgList?.length === 0 ? 
                (
                  <MessageList.Content>
                  <span
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(255, 255, 255, 0.7)', // light overlay
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      zIndex: 999,
                    }}
                  > 
                    <label style={{marginLeft: "10px",fontSize: "larger",marginBottom: "5px"}}><output>No Messages Found</output></label>
                  </span>
                  </MessageList.Content>
                ) :
                  (() => {
                    const hasMsgs = !Array.isArray(driverCardMsgList) && driverCardMsgList && driverCardMsgList.msgList;
                    if (!hasMsgs) return "";
                    
                    let displayMsgList = driverCardMsgList.msgList;
                    const isAllAffBroadcastActive = driverCardMsgList?.cardKey?.split('|')[0] === 'all';
                    if (isAllAffBroadcastActive) {
                      const consolidated = [];
                      displayMsgList.forEach(item => {
                        const msgValCleaned = (item.msgString || '').replace(/\^PV|\^P|\^V/g, '').trim();
                        const itemTimeStr = item.msgTime ? item.msgTime.replace(/[\sT]+/g, ' ').trim() : '';
                        const itemTime = itemTimeStr !== '' ? new Date(itemTimeStr) : new Date();
                        
                        const isDuplicate = consolidated.some(existing => {
                          const existingValCleaned = (existing.msgString || '').replace(/\^PV|\^P|\^V/g, '').trim();
                          const existingTimeStr = existing.msgTime ? existing.msgTime.replace(/[\sT]+/g, ' ').trim() : '';
                          const existingTime = existingTimeStr !== '' ? new Date(existingTimeStr) : new Date();
                          const timeDiff = Math.abs(itemTime - existingTime); // difference in ms
                          
                          return existing.msgFrom === item.msgFrom &&
                                 existingValCleaned === msgValCleaned &&
                                 timeDiff <= 10000; // 10 seconds tolerance
                        });
                        
                        if (!isDuplicate) {
                          consolidated.push(item);
                        }
                      });
                      displayMsgList = consolidated;
                    }
                    
                    return displayMsgList.map((item, index) => {
                      // Get the color for the current sender from the pre-generated map
                      const bgColor = senderColorMap.get(item.msgFrom);
                      const uniqueClass = `sender-${item.msgFrom.replace(/[^a-zA-Z0-9]/g, '')}`;
          
                      const msgKey = String(driverCardMsgList.driverName) !== String(item.msgFrom);
                      const msgVal = item.msgString;
                      const hasPV = /\^PV|\^P|\^V/.test(msgVal);
                      const cleanedMsg = msgVal.replace(/\^PV|\^P|\^V/g, '').trim();
                      const direction = msgKey ? 'outgoing' : 'incoming';
                      const cleanedDateTime = (item.msgTime ? item.msgTime.replace(/[\sT]+/g, ' ').trim() : '');
                      const DateExtracted = (cleanedDateTime !== '' ? cleanedDateTime.split(' ')[0]: '');
                      const cleanedDateVal = (item.msgTime ? DateExtracted.split('-')[1]+"/"+DateExtracted.split('-')[2]+"/"+DateExtracted.split('-')[0] : '');
                      const timeArr = cleanedDateTime !== '' && cleanedDateTime.split(" ")[1].includes(':') ? cleanedDateTime.split(" ")[1].split(":") : [];
                      const timeFormatted = timeArr.length > 0 ? timeArr[0] + ":" + timeArr[1] : '';
                      const sentTimeVal = (givenDateRange.toLowerCase() === 'today' ? timeFormatted : cleanedDateVal + ' ' + timeFormatted);
                      const messageAffiliateID = item.AffiliateID || item.affiliateID || "";
                      const messageAffiliateName = messageAffiliateID && String(messageAffiliateID) !== "-1"
                        ? getAffiliateName(messageAffiliateID, item.AffiliateName || item.affiliateName || "")
                        : "";
                      const senderName = isAllAffBroadcastActive
                        ? `${item.msgFrom} (All Affiliates)`
                        : (messageAffiliateName && isAllAffiliatesSelected()
                          ? `${item.msgFrom} (${messageAffiliateName})`
                          : item.msgFrom);
                      let includedMsgType = '';

                      // H-2 fix: replaced document.createElement('style') + document.head.appendChild
                      // which accumulated unbounded <style> nodes on every render (memory leak).
                      // React inline styles are the standard pattern for per-element dynamic styling.
                      const senderInlineStyle = { backgroundColor: bgColor };
                      // The outgoing sender-name rule is a one-time global style — inject once via id guard.
                      if (!document.getElementById('cs-outgoing-sender-style')) {
                        const staticStyle = document.createElement('style');
                        staticStyle.id = 'cs-outgoing-sender-style';
                        staticStyle.innerHTML = '.cs-message--outgoing .cs-message__sender-name { display: block !important; }';
                        document.head.appendChild(staticStyle);
                      }
          
                      if(hasPV){
                        includedMsgType = (msgVal.includes('^PV') ? (' (❐ 🔈)'): msgVal.includes('^P') ? ' (❐)' : msgVal.includes('^V') ? ' (🔈)' : '');
                      }
                      if (allMsgToDriverFlag === true) {
                        return(
                            <Message
                              key={`${index}-${item.MessageID}`}
                              className={uniqueClass}
                              model={{
                                message: cleanedMsg,
                                sentTime: sentTimeVal,
                                direction: direction,
                                position: "single",
                                sender: senderName
                              }}

                              children={<Message.Header style={{fontSize:'smaller'}} sender={senderName} sentTime={sentTimeVal + includedMsgType}/>}
                            />
                        )
                      }
                      else{
                        return (
                          <Message
                            key={`${index}-${item.MessageID}`}
                            model={{
                              message: cleanedMsg,
                              sentTime: sentTimeVal,
                              direction: direction,
                              position: "single",
                              sender: senderName
                            }}
                            children={<Message.Header style={{fontSize:'smaller'}} sender={senderName} sentTime={sentTimeVal + includedMsgType}/>}
                          />
                        )
                      }
                      
                    });
                  })()
                }
                
              </MessageList>

              <div as={MessageInput}>
                

                {chatType === 'chat' ?
                ////////////////////////// 
                // Normal chat selected //
                //////////////////////////
                  <>
                    <MessageInput autoFocus ref={messageInputRef} placeholder="Type message here..." attachButton={false} onSend={handleMsgSent}/>
                    <span className='float-end text-end my-auto mb-1 me-1 d-inline-flex' style={{cursor:"pointer"}} 
                      title={(sendMsgOptionsFlag.voice ? "Turn off voice message" : "Turn on voice message")} onClick={(e)=>{setSendMsgOptionsFlag(prev=>({...prev, voice:!prev.voice}));}}
                    >
                      <Icon className={`${sendMsgOptionsFlag.voice ? 'MessagingChatIconActive' : 'MessagingChatIconInActive'} mx-1 my-auto`} 
                        style={{width:"20px", minWidth:"20px", height:"20px"}} icon={(!sendMsgOptionsFlag.voice ? 'ion:volume-mute-outline': 'ion:volume-high-outline')}
                      /> 
                      
                    </span>
                    <span className='float-end text-end me-1 my-auto d-inline-flex' style={{cursor:"pointer"}} 
                      title={(sendMsgOptionsFlag.popup ? "Turn off popup message" : "Turn on popup message")} onClick={(e)=>{setSendMsgOptionsFlag(prev=>({...prev, popup:!prev.popup}));}}
                    >
                      <Icon className={`${sendMsgOptionsFlag.popup ? 'MessagingChatIconActive' : 'MessagingChatIconInActive'} my-auto`} 
                        style={{width:"20px", minWidth:"20px", height:"20px"}} icon={(!sendMsgOptionsFlag.popup ? 'material-symbols-light:select-window-off' : 'material-symbols:select-window')}
                      /> 
                    </span>
                  </>
                :
                ///////////////////////////
                // Special chat selected //
                ///////////////////////////
                  <>
                    <Row className="m-0 border-top">
                      <Col className="mt-1">
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtSpecialMsgTitle"
                          rows={1}
                          cols={20}
                          onKeyDown={(e)=>{

                          }}
                          placeholder="Enter a title..."
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtSpecialMsgTitle"
                          style={{resize:"none", minWidth:"84px", backgroundColor: '#c7e3f9'}} autoComplete="new_pass"
                          value={specialMsgDetails.title} onChange={(e)=>{setSpecialMsgDetails(prev=>({...prev, title: e.target.value}));}}
                          className="tripDetails-label-dataFields px-1 d-block w-100 callAgentInputStyle"
                        />
                      </Col>
                    </Row>
                    <Row className="m-0 my-1">
                      <Col>
                        <textarea
                          name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtSpecialMsgBody"
                          rows={4}
                          cols={20}
                          onKeyDown={(e)=>{

                          }}
                          placeholder="Enter a message..."
                          id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtSpecialMsgBody"
                          style={{resize:"none", minWidth:"84px", backgroundColor: '#c7e3f9'}} autoComplete="new_pass"
                          value={specialMsgDetails.body} onChange={(e)=>{setSpecialMsgDetails(prev=>({...prev, body: e.target.value}));}}
                          className="tripDetails-label-dataFields px-1 d-block w-100 callAgentInputStyle"
                        />
                      </Col>
                    </Row>
                    <Row className="m-0 mb-1">
                      <Col className="d-flex justify-content-end my-auto">
                        {/* <Button variant="info" tabIndex={0} className="me-2 my-auto rounded-circle d-inline-flex text-center justify-content-center" 
                          style={{ borderRadius: "0px", height:'35px', maxHeight:'35px', width:'35px', maxWidth:'35px'}} title={"Refresh special message history"}
                          onClick={refreshSpecialMsgHistory}
                        >
                          <Icon className={'text-white m-auto text-center'} style={{width:"20px", minWidth:"20px", height:"20px", minHeight:'20px'}} 
                            icon={'flowbite:refresh-outline'}
                          />
                        </Button> */}
                        <select className='text-center callAgentInputStyle raised-button my-auto me-2 messagingDateRangeSelect d-inline-flex' 
                          style={{minWidth:"120px", maxHeight:"30px", height:"30px", backgroundColor: '#c7e3f9'}} value={specialMsgDetails.option}
                          onChange={(e)=>{setSpecialMsgDetails(prev=>({...prev, option: e.target.value}));}}
                        >
                          <option value={"OK"}>{"OK"}</option>
                          <option value={"OK/Cancel"}>{"OK/Cancel"}</option>
                          <option value={"Yes/No/Cancel"}>{"Yes/No/Cancel"}</option>
                        </select>
                        <Button tabIndex={0} className="border-0 my-auto rounded d-inline-block raised-button messagingBtnStyle" 
                          style={{ borderRadius: "0px", height:'35px', maxHeight:'35px'}} disabled
                          onClick={handleSendSpecialMsg}
                        >
                          {"Send"}
                        </Button>
                      </Col>
                    </Row>
                  </>
                }
              </div>
            </ChatContainer>
          </MainContainer>
        </Col>
      </Row>
      {
        //////////////////////////////////////
        // Footer with Special/Chat options //
        //////////////////////////////////////
        <Row className="m-0 p-1 page-footer fixed-bottom" style={{backgroundColor:"#2e3942", height:'45px', maxHeight:'45px'}}>
          <Col className="text-end my-auto">
            
            
              {/* <p className='m-0 mx-1 my-auto text-white px-1 fw-bold float-end bg-light HeaderAlertResponsive shadow user-select-none d-flex messagingToggleShadow' 
                style={{borderRadius:"20px", height:'38px', maxHeight:'38px'}}
              >
                <Button variant="secondary" tabIndex={0} className={`messagingToggleBtn ${chatType ==='special' ? 'active': ''} border-0 small my-auto raised-button`} 
                  onClick={()=>{setChatType('special');}}
                >
                  {"Special"}
                </Button>
                <Button variant="secondary" tabIndex={0} className={`messagingToggleBtn ${chatType ==='chat' ? 'active': ''} ms-2 border-0 small my-auto raised-button`} 
                  onClick={()=>{setChatType('chat'); setSpecialMsgDetails({title:'', body: '', option: 'OK'});}}
                >
                  {"Chat"}
                </Button>
              </p> */}
            
            
            {/* 
              <Button variant="secondary" tabIndex={0} className="mx-1 rounded" style={{ borderRadius: "0px", height:'38px', maxHeight:'38px'}} 
                onClick={()=>{setOpenMsgScheduleView(true); setCreateGroupFlag(false);}}
              >
                {"Schedule"}
              </Button> */ //ABOVE IS FOR REMOVAL OF SCHEDULED MESSAGES - LEFT FOR FUTURE USE
            }
          </Col>
        </Row>}
      {//////////////////////
       // Schedule Message //
       //////////////////////
        openMsgScheduleView ? 
        <Modal centered backdrop="static" keyboard={true} size={"lg"} onHide={()=>{setOpenMsgScheduleView(false); setShowAddScheduleDisplay(false);}} 
          show={openMsgScheduleView} animation={true}
        >
          <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
            <Modal.Title style={{fontSize:"20px"}}>{"Schedule View"}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='fw-normal user-select-none'>
            <Row className={`m-0`}>
              <Col className={`p-0 ${showAddScheduleDisplay ? 'd-none' : ''}`}>
                <GridControl ShowLoader={showLoader} ReloadDataFunction={(e)=>{}} 
                  Data={msgSchGridData} options={MsgSchGridOptions}
                /> 
              </Col>
              <Col className={`p-0 ${showAddScheduleDisplay ? '' : 'd-none'}`}>
                <Row>
                  <Col className="" xs={6}>
                    <span className="d-flex my-auto">
                      <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{width:'100px', minWidth:'100px', textOverflow:"ellipsis"}}>
                        {"Schedule Name"}
                      </p>
                      <input type={"text"} className="text-nowrap p-0 px-1 callAgentInputStyle d-inline-flex" 
                        style={{maxHeight:"30px", height:"30px", width:'189px', minWidth:'189px'}} 
                        onChange={(e)=>{setCreateSchDetails(prev=>({...prev, name: e.target.value}));}} value={createSchDetails.name}
                      />
                    </span>
                    <span className="d-flex my-auto mt-1">
                      <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{width:'100px', minWidth:'100px', textOverflow:"ellipsis"}}>
                        {"Driver(s)"}
                      </p>
                      <MultiSelectDropdown options={DriversFilterMultiSelect} disablePreSelectedValues={true} 
                        SelectionChangeCallback={(e)=>{
                          GenericSelectCallback(e, 'drivers', DriversFilterMultiSelect, 
                            SetDriversFilterMultiSelect, setMultiSelectValuesSelected
                          );
                        }} FireSelectEventOnEveryItemChange={true}
                      />
                    </span>
                    <span className="d-flex my-auto mt-1">
                      <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{width:'100px', minWidth:'100px', textOverflow:"ellipsis"}}>
                        {"Time"}
                      </p>
                      <input type={"time"} className="text-nowrap justify-content-center p-0 px-1 callAgentInputStyle d-inline-flex text-center m-0" 
                        style={{maxHeight:"30px", height:"30px", width:'189px', minWidth:'189px'}} 
                        onChange={(e)=>{setCreateSchDetails(prev=>({...prev, time: e.target.value}));}} value={createSchDetails.time}
                      />
                    </span>
                  </Col>
                  <Col xs={6}>
                    <span className="d-flex my-auto mt-1">
                      <span className="d-inline-flex" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Monday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.mon} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, mon:e.target.checked}}));}}
                        />
                      </span>
                      <span className="d-inline-flex ms-1" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Tuesday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.tue} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, tue:e.target.checked}}));}}
                        />
                      </span>
                      <span className="d-inline-flex ms-1" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 text-center my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Wednesday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.wed} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, wed:e.target.checked}}));}}
                        />
                      </span>
                      
                    </span>
                    <span className="d-flex my-auto">
                      <span className="d-inline-flex" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Thursday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.thurs} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, thurs:e.target.checked}}));}}
                        />
                      </span>
                      <span className="d-inline-flex ms-1" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 text-center my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Friday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.fri} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, fri:e.target.checked}}));}}
                        />
                      </span>
                      <span className="d-inline-flex ms-1" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 text-center my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Saturday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.sat} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, sat:e.target.checked}}));}}
                        />
                      </span>
                    </span>
                    <span className="d-flex my-auto">
                      <span className="d-inline-flex" style={{width:'90px', maxWidth:'90px'}}>
                        <p className="m-0 my-auto user-select-none text-nowrap overflow-hidden d-inline-flex small" style={{textOverflow:"ellipsis", width:'70px'}}>
                          {"Sunday"}
                        </p>
                        <input type={'checkbox'} className="d-inline-flex ms-1" checked={createSchDetails.days.sun} style={{cursor:'pointer'}} 
                          onChange={(e)=>{setCreateSchDetails(prev=>({...prev, days: {...prev.days, sun:e.target.checked}}));}}
                        />
                      </span>
                    </span>
                    <span className="d-flex my-auto mt-1" style={{width:'120px', borderRadius:'4px'}}>
                      <span className="d-inline-flex my-auto ms-1" style={{cursor:'pointer'}} onClick={(e)=>{setAddSchToggleOptions(prev=>({...prev, recurring:!prev.recurring}));}}
                        title={addSchToggleOptions.recurring ? 'Turn off recurring status' : 'Turn on recurring status'}
                      >
                        <Icon className={`my-auto ${addSchToggleOptions.recurring ? 'text-success' : 'text-secondary'}`}
                          style={{width:"20px", height:"20px"}} 
                          icon={(addSchToggleOptions.recurring ? 'mdi:calendar-sync' : 'lucide:calendar-x-2')}
                        /> 
                      </span>
                      <span className="d-inline-flex my-auto ms-4" style={{cursor:'pointer'}} onClick={(e)=>{setAddSchToggleOptions(prev=>({...prev, popup:!prev.popup}));}} 
                        title={addSchToggleOptions.popup ? 'Turn off popup status' : 'Turn on popup status'}
                      >
                        <Icon className={`my-auto ${addSchToggleOptions.popup ? 'text-success' : 'text-secondary'}`} 
                          style={{width:"20px", height:"20px"}} 
                          icon={(addSchToggleOptions.popup ? 'material-symbols:select-window' : 'material-symbols-light:select-window-off')}
                        /> 
                      </span>
                      <span className="d-inline-flex my-auto ms-4" style={{cursor:'pointer'}} onClick={(e)=>{setAddSchToggleOptions(prev=>({...prev, active:!prev.active}));}} 
                        title={addSchToggleOptions.active ? 'Turn off active status' : 'Turn on active status'}
                       >
                        <Icon className={`my-auto ${addSchToggleOptions.active ? 'text-success' : 'text-secondary'}`} 
                          style={{width:"20px", height:"20px"}} 
                          icon={(addSchToggleOptions.active ? 'mdi:account-badge' : 'mdi:account-cancel')}
                        /> 
                      </span>
                    </span>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col>
                    <textarea
                      name="ctl00$ctl00$ContentPlaceHolder1$ContentPlaceHolder1$txtExtraCreateSch"
                      rows={4}
                      cols={20}
                      onKeyDown={(e)=>{

                      }}
                      placeholder="Enter a schedule message..."
                      id="ctl00_ctl00_ContentPlaceHolder1_ContentPlaceHolder1_txtExtraCreateSch"
                      style={{resize:"none", minWidth:"84px", backgroundColor: '#c7e3f9'}} autoComplete="new_pass"
                      value={createSchDetails.extra} onChange={(e)=>{setCreateSchDetails(prev=>({...prev, extra: e.target.value}));}}
                      className="tripDetails-label-dataFields px-1 d-block w-100 callAgentInputStyle"
                    />
                  </Col>
                </Row>
              </Col>
            </Row> 
          </Modal.Body>
          <Modal.Footer className='p-0 px-2 py-1'>
            <Button variant="warning" tabIndex={0} className={`border-0 small my-auto raised-button ${showAddScheduleDisplay ? 'd-none' : ''}`} 
              onClick={()=>{}}
            >
              {"Refresh Grid"}
            </Button>
            <Button variant="secondary" tabIndex={0} className={`border-0 small my-auto raised-button ${showAddScheduleDisplay ? '' : 'd-none'}`} 
              onClick={()=>{resetCreateScheduleFields();}}
            >
              {"Close"}
            </Button>
            <Button variant="dark" tabIndex={0} className={`border-0 small my-auto raised-button`} 
              onClick={(e)=>{
                const btnTxt = e.target.textContent.toLowerCase();
                if(btnTxt.includes('add')) {setShowAddScheduleDisplay(true);}
                else { 
                  //Create Schedule View
                  resetCreateScheduleFields();
                }
              }}
            >
              {(showAddScheduleDisplay ? "Create Schedule" : "Add Schedule")}
            </Button>
          </Modal.Footer>
        </Modal>
      : ""}
      
          <Modal show={scheduleDialog.Display} centered backdrop="static" keyboard={true} size={"xl"} animation={true} 
            onHide={
              (e) => setScheduleDialog(prev => ({ ...prev, Display: false, URL: "" }))
            }>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 dispatch_action_dialog_header_bgcolor' closeButton>
              <Modal.Title style={{fontSize:"20px"}}>{scheduleDialog.isLoading ? "Preparing Schedule..." : "Schedule & View Messages"}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: 0, position: 'relative', minHeight: '550px' }}>
               {scheduleDialog.isLoading && (
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(255,255,255,0.9)',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000
                }}>
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-2 text-muted">Authenticating and loading schedule...</p>
                </div>
              )}
              <iframe src={scheduleDialog.URL} title="Embedded Content" width="100%" height="575px" 
              style={{ 
                border: 'none',
                visibility: scheduleDialog.isLoading ? 'hidden' : 'visible'
              }}
              onLoad={() => {
                // This fires when iframe content is fully loaded
                setScheduleDialog(prev => ({ ...prev, isLoading: false }));
              }}/>
            </Modal.Body>
          </Modal>
       
    </>
  );

}


export default Messaging;
